<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0">
            <v-layout row wrap>
              <v-flex xs10>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="mdi-account-search-outline"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search Project Name':'Search'"
                single-line
                hide-details
                v-model="search"
                @input="searchProjectTitle(search)"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs2 class="text-right pt-4">
                <v-chip :class="isClosedProject ? 'info dark' : '' " @click="showClosedProjects()">Show Closed Projects</v-chip>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="px-0">
            <v-flex xs12>
              <v-card>
                <v-expansion-panels :value="selTab">
                  <v-expansion-panel v-for="(proj_name, i) in onboardReviewProjList" :key="i">
                    <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                      <div class="subtitle-2">{{proj_name}}</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-3">
                      <v-data-table
                      :headers="onboardSummaryListHeader"
                      :items="lOnboardReviewSummaryList.filter(rec => rec.proj_name === proj_name)"
                      hide-default-footer
                      dense
                      disable-pagination
                      :mobile-breakpoint="0"
                      class="elevation-1">
                        <template slot="item" slot-scope="props">
                          <tr @click="prepareUpdate(props.item)" :class="props.item.proj_status === 'Closed' ? 'grey--text' : ''">
                            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 12px;">{{ props.item.current_dept }}</td>
                            <td style="font-size: 12px;">{{ props.item.version_no }}</td>
                            <td style="font-size: 12px;">{{ props.item.project_contract_version ? props.item.project_contract_version : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.contract_amt_with_tax ? handy.formatCur(props.item.contract_amt_with_tax) : '-' }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-flex>
          </v-card-text>
        </v-card>

        <!-- 1. create, update of Onboarding Review -->
        <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
          <v-layout row wrap>
            <v-flex xs12 class="mt-2">
              <v-form ref="pForm" @submit.prevent="saveOnboardReviewBaseChanges(lAction)">
                <v-card>
                  <v-card-title class="py-2 grey lighten-3">
                    <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <span style="font-size: 17px" class="font-weight-bold pl-2 primary--text">{{ handy.startWithUpper(lAction) + ' Onboarding Review' }}</span>
                  </v-card-title>
                  <v-card-text class="pb-0 pt-2">
                    <v-layout>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs3>
                            <v-combobox
                            v-model="lOnboardReviewBase.comm_pair"
                            :items="commList"
                            item-text="comm_name"
                            item-value="comm_id"
                            label="Community"
                            hide-details
                            dense
                            outlined
                            style="font-size: 12px"
                            color="primary"
                            :disabled="lAction === 'update'"
                            :rules="[rules.required]"
                            ></v-combobox>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                            <v-btn small icon :disabled="!lOnboardReviewBase.comm_pair.comm_id" @click="showBasicInformationOfCommunity(lOnboardReviewBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                          </v-flex>
                          <v-flex xs3>
                            <v-combobox
                            v-model="lOnboardReviewBase.proj_pair"
                            :items="projList"
                            item-text="proj_name"
                            item-value="proj_id"
                            label="Project"
                            hide-details
                            dense
                            outlined
                            style="font-size: 12px"
                            color="primary"
                            clear-icon="mdi-close-circle-outline"
                            :disabled="lAction === 'update'"
                            ></v-combobox>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                            <v-btn small icon :disabled="!lOnboardReviewBase.proj_pair.proj_id" @click="showBasicInformationOfProject(lOnboardReviewBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                          </v-flex>
                          <v-flex xs3>
                            <v-autocomplete
                            v-model="lOnboardReviewBase.proj_contract_base_id"
                            :items="projContractList"
                            item-text="contract_version"
                            item-value="proj_contract_base_id"
                            label="Project Contract Ver"
                            hide-details
                            dense
                            outlined
                            clear-icon="mdi-close-circle-outline"
                            style="font-size: 12px"
                            color="primary"
                            @input="changeProjectContractBaseIDforOnboardReview()"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                            <v-btn small icon :disabled="!lOnboardReviewBase.proj_contract_base_id" @click="showBasicInformationOfProjectContract(lOnboardReviewBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                          </v-flex>
                          <v-flex xs3>
                            <v-dialog ref="dlgDate"
                            persistent v-model="dlgDate"
                            max-width="290px"
                            :return-value.sync="lOnboardReviewBase.on_boarding_date">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="On-boarding Date"
                                v-model="lOnboardReviewBase.on_boarding_date" append-icon="mdi-calendar-today"
                                readonly
                                v-on="on"
                                hide-details
                                outlined
                                dense
                                :disabled="disableSubmitButton"
                                color="primary"
                                style="font-size: 12px"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lOnboardReviewBase.on_boarding_date"
                              :disabled="disableSubmitButton"
                              first-day-of-week="1">
                                <v-spacer></v-spacer>
                                <v-btn text @click="dlgDate = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.dlgDate.save(lOnboardReviewBase.on_boarding_date)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 3%">
                          </v-flex>
                          <v-flex xs3 class="ml-2">
                            <v-autocomplete
                            v-model="lVersion"
                            label="Sales Review Version"
                            :items="versionList"
                            item-text="version"
                            item-value="mi_base_id"
                            hide-details
                            outlined
                            style="font-size: 12px"
                            dense
                            color="primary"
                            :disabled="lAction === 'update'"
                            @input="loadTheDetailsAndBaseThingsBasedOnSelectedVersion(lVersion)"
                            >
                            </v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs1>
                        <v-layout>
                          <v-flex xs3 style="flex-basis: 0%" class="pt-2">
                            <v-btn small :disabled="disableSubmitButton" style="width: 100px; margin-left: -40px" class="accent" v-if="config.IS_EDITED_BY_USER" type="submit">save</v-btn>
                            <v-btn small style="width: 100px; margin-left: -40px" class="mt-2 success white--text" @click="validateOnbPlannerStatus()">Validate</v-btn>
                            <v-btn small style="width: 100px; margin-left: -40px" class="mt-2 uniformchipinfo white--text" @click="prepareOnboardingReviewView()">view</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-flex xs12>
                      <v-layout row wrap class="pt-3 pa-0" v-if="showContractImportSection && this.lOnboardReviewBase.current_dept != 'Closed'">
                        <v-flex xs12>
                          <v-alert class="warning">
                            <v-layout v-if="this.lOnboardReviewBase.current_dept === source_var" row wrap class="pa-0">
                              <v-flex xs11>
                                <div class="white--text font-weight-bold" style="font-size: 15px;">New Approved Contract {{ this.lOnboardReviewBase.new_proj_contract_version_no }} is avaiable for project "<strong><u>{{ lOnboardReviewBase.proj_pair.proj_name }}</u></strong>". Click import to add new approved contract details. </div>
                              </v-flex>
                              <v-flex xs1>
                                <div class="white--text font-weight-bold" style="font-size: 15px;"><v-btn small :disabled="disableSubmitButton" class="ml-2 accent" v-if="config.IS_EDITED_BY_USER" @click="importNewApprovedContractDetails()">Import</v-btn> </div>
                              </v-flex>
                            </v-layout>
                            <v-layout v-if="this.lOnboardReviewBase.current_dept != source_var" row wrap class="pa-0">
                              <v-flex xs12>
                                <div class="white--text font-weight-bold" style="font-size: 15px;">New Approved Contract {{ this.lOnboardReviewBase.new_proj_contract_version_no }} is avaiable for project "<strong><u>{{ lOnboardReviewBase.proj_pair.proj_name }}</u></strong>". Click import from <strong><u>{{ this.lOnboardReviewBase.current_dept }} Review</u></strong> to add new approved contract details. </div>
                              </v-flex>
                            </v-layout>
                          </v-alert>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <v-expansion-panels multiple v-model="panel">
                    <!-- Onboarding Planner Details Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                        <div class="subtitle font-weight-bold">Onboarding Planner Details</div>
                        <v-flex xs8 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-chip small :class="isShowOnlyPendingItems ? 'info dark font-weight-bold' : 'grey darken-1 white--text font-weight-bold' " onclick="event.stopPropagation()" @click="loadOnlyPendingItems()">Show Only Pending Items</v-chip>
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareCreateOnboardingPlanner()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareOnboardingPlannerImport(onboardPlannerReviewItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                            </template>
                            <span>Import</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2">
                        <v-expansion-panels :value="selTab">
                          <v-expansion-panel v-for="(cat, i) in onboardCat" :key="i">
                            <v-expansion-panel-header style="min-height: 40px;" class="py-1 grey lighten-3">
                              <div class="font-weight-bold primary--text body-2">
                                {{cat}}
                              </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content style="margin-left: -15px; margin-right: -15px" class="mt-2">
                              <v-data-table
                              :headers="onboardPlannerReviewItemHeader"
                              :items="onboardPlannerReviewItemList.filter(rec => rec.onb_planner_cat === cat)"
                              hide-default-footer
                              disable-pagination
                              dense
                              :mobile-breakpoint="0">
                                <template slot="item" slot-scope="props">
                                  <tr :class="(props.item.onb_status === 'Not Started' || props.item.onb_status === 'In-Progress' || props.item.onb_status === 'On-Hold') ? 'red--text' : ''" @click="disableSubmitButton || props.item.onb_source != source_var ? '' : prepareOnbPlannerUpdate(props.item)">
                                    <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                                    <td style="font-size: 12px;">{{ props.item.onb_planner_sub_cat }}</td>
                                    <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                                    <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDate(props.item.onb_plan_end_dt) : '-' }}</td>
                                    <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDate(props.item.onb_actual_end_dt) : '-' }}</td>
                                    <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_onb_complete ? 'Yes' : 'No' }}</td>
                                    <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_asset_recoverable ? 'Yes' : 'No' }}</td>
                                    <td style="font-size: 12px;">{{ props.item.onb_status }}</td>
                                    <td style="font-size: 12px;">{{ props.item.onb_remarks ? props.item.onb_remarks : '-' }}</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Manpower Hiring and Deployment (in-house) expansion panel - do not show the roles if it is outsourced -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                        <div class="subtitle font-weight-bold">Manpower Hiring and Deployment (in-house)</div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareOnBoardRemainingMandepImport()"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                            </template>
                            <span>Import</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="manpowerDepInHouseItemHeader"
                        :items="manpowerDepInHouseItemList"
                        hide-default-footer
                        disable-pagination
                        fixed-header
                        dense
                        :mobile-breakpoint="0">
                          <template slot="item" slot-scope="props">
                            <tr :class="(props.item.onb_status === 'Not Started' || props.item.onb_status === 'In-Progress' || props.item.onb_status === 'On-Hold') ? 'red--text' : ''"  @click="disableSubmitButton || props.item.onb_source != source_var ? '' : prepareManDepInhouseDetUpdate(props.item)">
                              <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_contract_hc }}</td>
                              <td style="font-size: 12px;">{{ props.item.onb_deployed_hc }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ props.item.onb_budget_cost ? handy.formatCur(props.item.onb_budget_cost) : '-' }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ props.item.onb_actual_cost ? handy.formatCur(props.item.onb_actual_cost) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDate(props.item.onb_plan_end_dt) : '-' }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDate(props.item.onb_actual_end_dt) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.onb_status ? props.item.onb_status : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.onb_remarks ? props.item.onb_remarks : '-' }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Vendor Engagement (Outsourced Services) expansion panel - Show only type is outsourced also should be in staff roles -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                        <div class="subtitle font-weight-bold">Manpower Vendor Engagement (Outsourced Services) </div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <!-- <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="warning--text" icon small :disabled="disableSubmitButton" @click="prepareCreateOnBoardManDepOutsource()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New</span>
                          </v-tooltip> -->
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareOnBoardRemainingMandepImport()"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                            </template>
                            <span>Import</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="manpowerDepOutsourceItemHeader"
                        :items="manpowerDepOutsourceItemList"
                        hide-default-footer
                        disable-pagination
                        fixed-header
                        dense
                        :mobile-breakpoint="0">
                          <template slot="item" slot-scope="props">
                            <tr :class="(props.item.onb_status === 'Not Started' || props.item.onb_status === 'In-Progress' || props.item.onb_status === 'On-Hold') ? 'red--text' : ''" @click="disableSubmitButton || props.item.onb_source != source_var ? '' : prepareManDepOutsourceDetUpdate(props.item)">
                              <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_contract_hc ? props.item.onb_contract_hc : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-'}}</td>
                              <td style="font-size: 12px;" class="text-right">{{ props.item.onb_budget_cost ? handy.formatCur(props.item.onb_budget_cost) : '-' }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ props.item.onb_actual_cost ? handy.formatCur(props.item.onb_actual_cost) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDate(props.item.onb_plan_end_dt) : '-' }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDate(props.item.onb_actual_end_dt) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.onb_status ? props.item.onb_status : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.onb_remarks ? props.item.onb_remarks : '-' }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Other Service Engagement expansion panel - Show only type is outsourced -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                        <div class="subtitle font-weight-bold">Other Services Engagement </div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <!-- <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="warning--text" icon small :disabled="disableSubmitButton" @click="prepareCreateOnBoardOtherService()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New</span>
                          </v-tooltip> -->
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareOnBoardRemainingOtherServiceImport(otherServiceEngageItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                            </template>
                            <span>Import</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="otherServiceEngageItemHeader"
                        :items="otherServiceEngageItemList"
                        hide-default-footer
                        disable-pagination
                        fixed-header
                        dense
                        :mobile-breakpoint="0">
                          <template slot="item" slot-scope="props">
                            <tr :class="(props.item.onb_status === 'Not Started' || props.item.onb_status === 'In-Progress' || props.item.onb_status === 'On-Hold') ? 'red--text' : ''" @click="disableSubmitButton || props.item.onb_source != source_var ? '' : prepareOtherServiceDetUpdate(props.item)">
                              <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="font-size: 12px;">{{ props.item.ser_role }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_ser_type ? props.item.onb_ser_type : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-' }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ props.item.onb_budget ? handy.formatCur(props.item.onb_budget) : '-' }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ props.item.onb_deployed_cost ? handy.formatCur(props.item.onb_deployed_cost) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDate(props.item.onb_plan_end_dt) : '-' }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDate(props.item.onb_actual_end_dt) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.onb_status ? props.item.onb_status : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.onb_remarks ? props.item.onb_remarks : '-' }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Voice Of Customer Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                        <div class="subtitle font-weight-bold">Voice Of Customer</div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareCreateVoiceofCust()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareVoiceofCustImport(voiceOfCustItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                            </template>
                            <span>Import</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="voiceOfCustItemHeader"
                        :items="voiceOfCustItemList"
                        hide-default-footer
                        hide-default-header
                        disable-pagination
                        dense
                        :mobile-breakpoint="0">
                          <template v-slot:header="{ props: { headers } }">
                            <thead>
                              <tr>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 50px; text-align: center ">{{headers[0].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[1].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[2].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[3].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 80px; text-align: center ">{{headers[4].text}}</th>
                              </tr>
                            </thead>
                          </template>
                          <template slot="item" slot-scope="props">
                            <tr @click="disableSubmitButton || props.item.source != source_var ? '' : prepareVoiceofCustUpdate(props.item)">
                              <td style="text-align:center; font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_voice_of_cust }}</td>
                              <td style="text-align:center; font-size: 12px;">{{ props.item.source }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_voice_of_cust_remarks }}</td>
                              <td style="text-align:center; font-size: 12px;"><v-btn class="ml-1 info--text" icon small @click.stop.prevent="prepareAddVoiceofCustHistory(props.item)"><v-icon>mdi-history</v-icon></v-btn></td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Customer Expectation Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
                        <div class="subtitle font-weight-bold">Customer Expectations</div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareCreateCustExpect()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareCustExpectImport(custExpectItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                            </template>
                            <span>Import</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="custExpectItemHeader"
                        :items="custExpectItemList"
                        hide-default-footer
                        hide-default-header
                        disable-pagination
                        dense
                        :mobile-breakpoint="0">
                          <template v-slot:header="{ props: { headers } }">
                            <thead>
                              <tr>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 50px; text-align: center ">{{headers[0].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 170px; text-align: left ">{{headers[1].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[2].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 100; text-align: left ">{{headers[3].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 120; text-align: center ">{{headers[4].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[5].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[6].text}}</th>
                              </tr>
                            </thead>
                          </template>
                          <template slot="item" slot-scope="props">
                            <tr @click="disableSubmitButton || props.item.source != source_var ? '' : prepareCustExpectUpdate(props.item)">
                              <td style="text-align:center; font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.category }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_cust_expectation }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_freq }}</td>
                              <td style="text-align:center; font-size: 12px;">{{ props.item.source }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_cust_expect_remarks }}</td>
                              <td style="text-align:center; font-size: 12px;"><v-btn class="ml-1 info--text" icon small @click.stop.prevent="prepareCustExpectHistory(props.item)"><v-icon>mdi-history</v-icon></v-btn></td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Uniservice Commitment Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
                        <div class="subtitle font-weight-bold">Uniservice Commitment</div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareCreateUniCommit()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareUniCommitImport(uniCommitItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                            </template>
                            <span>Import</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="uniCommitItemHeader"
                        :items="uniCommitItemList"
                        hide-default-footer
                        hide-default-header
                        disable-pagination
                        dense
                        :mobile-breakpoint="0">
                          <template v-slot:header="{ props: { headers } }">
                            <thead>
                              <tr>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 50px; text-align: center ">{{headers[0].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 170px; text-align: left ">{{headers[1].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[2].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 100; text-align: left ">{{headers[3].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 100; text-align: center ">{{headers[4].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[5].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[6].text}}</th>
                              </tr>
                            </thead>
                          </template>
                          <template slot="item" slot-scope="props">
                            <tr @click="disableSubmitButton || props.item.source != source_var ? '' : prepareUniCommitUpdate(props.item)">
                              <td style="text-align:center; font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.category }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_uni_commit }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_freq }}</td>
                              <td style="text-align:center; font-size: 12px;">{{ props.item.source }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_uni_commit_remarks }}</td>
                              <td style="text-align:center; font-size: 12px;"><v-btn class="ml-1 info--text" icon small @click.stop.prevent="prepareUniCommitHistory(props.item)"><v-icon>mdi-history</v-icon></v-btn></td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Feedback/Snag Audit action Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
                        <div class="subtitle font-weight-bold">Feedback/Snag Audit Action Item</div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareCreateSnagAuditAction()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="onbSnagAuditActionItemHeader"
                        :items="snagAuditActionItemList"
                        hide-default-footer
                        disable-pagination
                        dense
                        :mobile-breakpoint="0">
                          <template slot="item" slot-scope="props">
                            <tr @click="disableSubmitButton || props.item.source != source_var ? '' : prepareSnagAuditActionUpdate(props.item)">
                              <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="font-size: 12px;">{{ props.item.category }}</td>
                              <td style="font-size: 12px;">{{ props.item.snag_des }}</td>
                              <td style="font-size: 12px;">{{ props.item.snag_action_des }}</td>
                              <td style="font-size: 12px;">{{ props.item.snag_priority }}</td>
                              <td style="font-size: 12px;">{{ props.item.status ? props.item.status : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.plan_end_dt ? handy.formatDate(props.item.plan_end_dt) : '-' }}</td>
                              <td style="font-size: 12px;" class="text-center">{{ props.item.actual_end_dt ? handy.formatDate(props.item.actual_end_dt) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.source ? props.item.source : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.remarks ? props.item.remarks : '-' }}</td>
                              <td style="text-align:center; font-size: 12px;"><v-btn class="ml-1 info--text" icon small @click.stop.prevent="prepareSnagAuditActionHistory(props.item)"><v-icon>mdi-history</v-icon></v-btn></td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Document Upload Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
                        <div class="subtitle font-weight-bold">Documents</div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton" @click="prepareUploadDocs()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New Document</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="docItemHeader"
                        :items="docItemList"
                        hide-default-footer
                        hide-default-header
                        disable-pagination
                        dense
                        :mobile-breakpoint="0">
                          <template v-slot:header="{ props: { headers } }">
                            <thead>
                              <tr>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 50px; text-align: center ">{{headers[0].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[1].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 120px; text-align: center ">{{headers[2].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 150; text-align: left ">{{headers[3].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 100; text-align: center ">{{headers[4].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250; text-align: left ">{{headers[5].text}}</th>
                              </tr>
                            </thead>
                          </template>
                          <template slot="item" slot-scope="props">
                            <tr @click="disableSubmitButton || props.item.source != source_var ? '' : updateDocItems(props.item)">
                              <td style="text-align:center; font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.file_name }}</td>
                              <td style="text-align:center;"><a :href="handy.loadImg(props.item.file_url)" download style="text-decoration: none;">
                                <v-btn small icon onclick="event.stopPropagation()" class="mr-1 info grey--text text--lighten-4">
                                  <v-icon small>mdi-download</v-icon>
                                </v-btn>
                              </a></td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_doc_type }}</td>
                              <td style="text-align:center; font-size: 12px;">{{ props.item.source }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_doc_remarks }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn small style="width: 100px;" class="success white--text" @click="validateOnbPlannerStatus()">Validate</v-btn>
                  <v-btn small v-if="config.IS_EDITED_BY_USER" class="warning" :disabled="disableSubmitButton || onboardPlannerReviewItemList.length === 0 || (voiceOfCustItemList.length === 0 && custExpectItemList.length === 0 && uniCommitItemList.length === 0 && docItemList.length === 0)" @click="onbReviewSubmtToOperation()">Submit to Operation</v-btn>
                  <v-btn small style="width: 100px;" class="uniformchipinfo white--text" @click="prepareOnboardingReviewView()">view</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- 2. Import Onboarding planner details from config -->
        <v-dialog v-model="showListOfOnboardingPlannerDet" persistent scrollable max-width="800px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Select Onboarding Planner
              <v-spacer></v-spacer>
              <v-btn icon small @click="showListOfOnboardingPlannerDet = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-flex xs12 class="pb-3">
                <v-autocomplete
                v-model="lOnbPlannerImportResponsible.onb_responsible_import_pair_id"
                label="Responsibility"
                item-value="emp_id"
                item-text="disp_short_name"
                :items="responsibilityEmpList"
                style="font-size: 14px"
                hide-details
                small-chips
                deletable-chips
                clearable
                outlined
                dense
                multiple
                ></v-autocomplete>
              </v-flex>
              <v-data-table
              v-model="selected"
              show-select
              :headers="onboardingPlannerDetHeadList"
              :items="onboardingPlannerDetList"
              hide-default-footer
              disable-sort
              disable-pagination
              dense
              item-key="mi_onb_sub_cat_id"
              class="elevation-1 importtableth importtabletd"
              style="font-size: 14px"
              :mobile-break-point="0">
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="importToOnboardingPlanner(selected)">Import to Onboarding Planner</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 3. Add or Update onboarding planner sub category -->
        <v-dialog v-model="showOnbPlanner" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveOnboardingPlannerChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                    {{lOnbPlanner.action ? handy.startWithUpper(lOnbPlanner.action) : ''}} Onboarding Planner
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showOnbPlanner = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnbPlanner.onb_planner_cat"
                        label="Onboarding Planner Category"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lOnbPlanner.action === 'update' && lOnbPlanner.onb_planner_sub_cat_id != null"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnbPlanner.onb_planner_sub_cat"
                        label="Onboarding Planner Sub Category"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lOnbPlanner.action === 'update' && lOnbPlanner.onb_planner_sub_cat_id != null"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs8 class="pt-2">
                        <v-autocomplete
                        v-model="lOnbPlanner.onb_responsible_pair_id"
                        label="Responsibility"
                        item-value="emp_id"
                        item-text="disp_short_name"
                        :items="responsibilityEmpList"
                        style="font-size: 14px"
                        hide-details
                        small-chips
                        deletable-chips
                        clearable
                        dense
                        multiple
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4>
                        <v-checkbox hide-details
                        label="Is Uniservice Asset?"
                        v-model="lOnbPlanner.mi_is_asset_recoverable"
                        class="my-label-text-size"
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex xs4>
                        <v-dialog ref="planEndDt"
                        persistent v-model="planEndDt"
                        max-width="290px"
                        :return-value.sync="lOnbPlanner.onb_plan_end_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Planned End Date"
                            v-model="lOnbPlanner.onb_plan_end_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lOnbPlanner.onb_plan_end_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="planEndDt = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.planEndDt.save(lOnbPlanner.onb_plan_end_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs4>
                        <v-dialog ref="actualEndDt"
                        persistent v-model="actualEndDt"
                        max-width="290px"
                        :return-value.sync="lOnbPlanner.onb_actual_end_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Actual End Date"
                            v-model="lOnbPlanner.onb_actual_end_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lOnbPlanner.onb_actual_end_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="actualEndDt = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.actualEndDt.save(lOnbPlanner.onb_actual_end_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                        v-model="lOnbPlanner.onb_status"
                        :items="status_list"
                        label="Status"
                        hide-details
                        style="font-size: 14px"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnbPlanner.onb_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs8>
                        <v-checkbox hide-details
                        label="Is this task completed by Onboarding Team?"
                        class="my-label-text-size"
                        v-model="lOnbPlanner.mi_is_onb_complete"
                        :disabled="config.ROLE_NAME != 'Super Admin' && (lOnbPlanner.action === 'update' && lOnbPlanner.onb_planner_sub_cat_id != null) "
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex xs4>
                        <div class="pt-5">Planner Source: <strong> {{lOnbPlanner.onb_source}} </strong></div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 4. Import onboarding mandep (inhouse and outsource) details -->
        <v-dialog v-model="showListOfOnbMandepImport" persistent scrollable max-width="700px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Select Manpower Detail from Contract
              <v-spacer></v-spacer>
              <v-btn icon small @click="showListOfOnbMandepImport = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-data-table
              v-model="selected"
              show-select
              :headers="onbMandepRemainingDetHeader"
              :items="onbMandepImportRemainingList"
              hide-default-footer
              disable-sort
              disable-pagination
              dense
              item-key="proj_contract_staff_det_id"
              class="elevation-1 importtableth importtabletd"
              :mobile-break-point="0">
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="importToOnbManpowerDeployment(selected)">Import to Manpower Details</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 5. Update onboarding manpower inhouse details -->
        <v-dialog v-model="showOnbManDepInhouseDet" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lFormMandepInhouse" @submit.prevent="saveManDepInhouseDetChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-3 py-2">
                    {{lOnbManpowerInhouseDet.action ? handy.startWithUpper(lOnbManpowerInhouseDet.action) : ''}} Manpower Hiring and Deployment (in-house)
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showOnbManDepInhouseDet = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs8>
                            <v-text-field
                            v-model="lOnbManpowerInhouseDet.staff_role"
                            label="Staff Role"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :disabled="lOnbManpowerInhouseDet.action === 'update'"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-checkbox hide-details
                            label="Is Outsourced"
                            v-model="lOnbManpowerInhouseDet.is_os"
                            class="ml-4 my-label-text-size"
                            :disabled="config.ROLE_NAME != 'Super Admin'"
                            >
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-text-field
                            v-model="lOnbManpowerInhouseDet.onb_contract_hc"
                            label="Contract (agreed) Head Count"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :disabled="lOnbManpowerInhouseDet.action === 'update'"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            v-model="lOnbManpowerInhouseDet.onb_deployed_hc"
                            label="Deployed Head Count"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-text-field
                            v-model="lOnbManpowerInhouseDet.onb_budget_cost"
                            label="Budget (Agreed) Cost/ CTC"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :disabled="lOnbManpowerInhouseDet.action === 'update'"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            v-model="lOnbManpowerInhouseDet.onb_actual_cost"
                            label="Actual Take Home"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 class="pt-2">
                        <v-autocomplete
                        v-model="lOnbManpowerInhouseDet.onb_responsible_pair_id"
                        label="Responsibility"
                        item-value="emp_id"
                        item-text="disp_short_name"
                        :items="responsibilityEmpList"
                        style="font-size: 14px"
                        hide-details
                        small-chips
                        deletable-chips
                        clearable
                        dense
                        multiple
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-dialog ref="inhousePlanEndDt"
                            persistent v-model="inhousePlanEndDt"
                            max-width="290px"
                            :return-value.sync="lOnbManpowerInhouseDet.onb_plan_end_dt"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Plan End Date"
                                v-model="lOnbManpowerInhouseDet.onb_plan_end_dt"
                                append-icon="mdi-calendar-today"
                                readonly clearable
                                hide-details
                                style="font-size: 14px"
                                v-on="on"
                                required
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lOnbManpowerInhouseDet.onb_plan_end_dt" scrollable
                              first-day-of-week="1"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text @click="inhousePlanEndDt = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.inhousePlanEndDt.save(lOnbManpowerInhouseDet.onb_plan_end_dt)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs4>
                            <v-dialog ref="inhouseActualEndDt"
                            persistent v-model="inhouseActualEndDt"
                            max-width="290px"
                            :return-value.sync="lOnbManpowerInhouseDet.onb_actual_end_dt"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Actual End Date"
                                v-model="lOnbManpowerInhouseDet.onb_actual_end_dt"
                                append-icon="mdi-calendar-today"
                                readonly clearable
                                hide-details
                                style="font-size: 14px"
                                v-on="on"
                                required
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lOnbManpowerInhouseDet.onb_actual_end_dt" scrollable
                              first-day-of-week="1"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text @click="inhouseActualEndDt = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.inhouseActualEndDt.save(lOnbManpowerInhouseDet.onb_actual_end_dt)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs4>
                            <v-autocomplete
                            v-model="lOnbManpowerInhouseDet.onb_status"
                            :items="status_list"
                            label="Status"
                            hide-details
                            style="font-size: 14px"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lOnbManpowerInhouseDet.onb_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 6. Update onboarding manpower outsource details -->
        <v-dialog v-model="showOnbManDepOutsourceDet" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lFormMandepOutsource" @submit.prevent="saveManDepOutsourceDetChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-3 py-2">
                    {{lOnbManpowerOutsourceDet.action ? handy.startWithUpper(lOnbManpowerOutsourceDet.action) : ''}} Manpower Vendor Engagement (Outsourced Services)
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showOnbManDepOutsourceDet = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs8>
                            <v-text-field
                            v-model="lOnbManpowerOutsourceDet.staff_role"
                            label="Staff Role"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :disabled="lOnbManpowerOutsourceDet.action === 'update'"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-checkbox hide-details
                            label="Is Outsourced"
                            v-model="lOnbManpowerOutsourceDet.is_os"
                            class="ml-4 my-label-text-size"
                            :disabled="config.ROLE_NAME != 'Super Admin'"
                            >
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-text-field
                            v-model="lOnbManpowerOutsourceDet.onb_contract_hc"
                            label="Contract (agreed) Head Count"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :disabled="lOnbManpowerOutsourceDet.action === 'update'"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                            v-model="lOnbManpowerOutsourceDet.onb_budget_cost"
                            label="Budget (Agreed) Cost"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :disabled="lOnbManpowerOutsourceDet.action === 'update'"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                            v-model="lOnbManpowerOutsourceDet.onb_actual_cost"
                            label="Actual Cost"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-autocomplete
                            v-model="lOnbManpowerOutsourceDet.vendorsupplier_cat_id"
                            :items="vendorSupplierCategoryList"
                            item-text="vendorsupplier_cat"
                            item-value="vendorsupplier_cat_id"
                            label="Vendor Category"
                            hide-details=
                            dense
                            clearable
                            style="font-size: 14px"
                            clear-icon="mdi-close-circle-outline"
                            @input="loadVendorSupplierSubCategoryList(lOnbManpowerOutsourceDet)"
                            @change="clearVendorSupplierSubCatDropdown()"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 class="pt-4">
                            <v-autocomplete
                            v-model="lOnbManpowerOutsourceDet.vendorsupplier_sub_cat_id"
                            :items="vendorSupplierSubCategoryList"
                            item-text="vendorsupplier_sub_cat"
                            item-value="vendorsupplier_sub_cat_id"
                            label="Vendor Sub-Category"
                            hide-details
                            dense
                            clearable
                            style="font-size: 14px"
                            clear-icon="mdi-close-circle-outline"
                            @input="loadVendorSupplierList(lOnbManpowerOutsourceDet)"
                            @change="clearVendorSupplierDropdown()"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-autocomplete
                            v-model="lOnbManpowerOutsourceDet.vendorsupplier_id"
                            :items="vendorSupplierList"
                            item-text="vendorsupplier_name"
                            item-value="vendorsupplier_id"
                            label="Vendor Name"
                            hide-details
                            dense
                            clearable
                            autocomplete
                            style="font-size: 14px"
                            clear-icon="mdi-close-circle-outline"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6>
                            <v-autocomplete
                            v-model="lOnbManpowerOutsourceDet.onb_responsible_pair_id"
                            label="Responsibility"
                            item-value="emp_id"
                            item-text="disp_short_name"
                            :items="responsibilityEmpList"
                            style="font-size: 14px"
                            hide-details
                            small-chips
                            deletable-chips
                            clearable
                            dense
                            multiple
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-dialog ref="outsourcePlanEndDt"
                            persistent v-model="outsourcePlanEndDt"
                            max-width="290px"
                            :return-value.sync="lOnbManpowerOutsourceDet.onb_plan_end_dt"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Plan End Date"
                                v-model="lOnbManpowerOutsourceDet.onb_plan_end_dt"
                                append-icon="mdi-calendar-today"
                                readonly clearable
                                hide-details
                                style="font-size: 14px"
                                v-on="on"
                                required
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lOnbManpowerOutsourceDet.onb_plan_end_dt" scrollable
                              first-day-of-week="1"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text @click="outsourcePlanEndDt = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.outsourcePlanEndDt.save(lOnbManpowerOutsourceDet.onb_plan_end_dt)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs4>
                            <v-dialog ref="outsourceActualEndDt"
                            persistent v-model="outsourceActualEndDt"
                            max-width="290px"
                            :return-value.sync="lOnbManpowerOutsourceDet.onb_actual_end_dt"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Actual End Date"
                                v-model="lOnbManpowerOutsourceDet.onb_actual_end_dt"
                                append-icon="mdi-calendar-today"
                                readonly clearable
                                hide-details
                                style="font-size: 14px"
                                v-on="on"
                                required
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lOnbManpowerOutsourceDet.onb_actual_end_dt" scrollable
                              first-day-of-week="1"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text @click="outsourceActualEndDt = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.outsourceActualEndDt.save(lOnbManpowerOutsourceDet.onb_actual_end_dt)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs4>
                            <v-autocomplete
                            v-model="lOnbManpowerOutsourceDet.onb_status"
                            :items="status_list"
                            label="Status"
                            hide-details
                            style="font-size: 14px"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lOnbManpowerOutsourceDet.onb_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 7. Import onboarding other service engagement details -->
        <v-dialog v-model="showListOfOnbOtherServiceImport" persistent scrollable max-width="700px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Select Other Service Engagement
              <v-spacer></v-spacer>
              <v-btn icon small @click="showListOfOnbOtherServiceImport = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-data-table
              v-model="selected"
              show-select
              :headers="onbOtherServiceRemainingDetHeader"
              :items="otherServiceImportRemainingList"
              hide-default-footer
              disable-sort
              disable-pagination
              dense
              item-key="proj_contract_service_det_id"
              class="elevation-1 importtableth importtabletd"
              :mobile-break-point="0">
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="importToOnbOtherServiceEngagement(selected)">Import to Other Services</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 8. Update onboarding other service engagement details -->
        <v-dialog v-model="showOnbOtherServiceDet" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lFormOtherService" @submit.prevent="saveOtherServiceDetChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-3 py-2">
                    {{lOnbOtherServiceDet.action ? handy.startWithUpper(lOnbOtherServiceDet.action) : ''}} Other Services Engagement
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showOnbOtherServiceDet = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnbOtherServiceDet.ser_role"
                        label="Service Description"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lOnbOtherServiceDet.action === 'update'"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-text-field
                            v-model="lOnbOtherServiceDet.onb_budget"
                            label="Budget (Agreed) Cost"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :disabled="lOnbOtherServiceDet.action === 'update'"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                            v-model="lOnbOtherServiceDet.onb_deployed_cost"
                            label="Deployed Cost"
                            hide-details
                            maxlength="100"
                            style="font-size: 14px"
                            :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-select
                            v-model="lOnbOtherServiceDet.onb_ser_type"
                            label="Service Type"
                            item-value="onb_ser_type"
                            item-text="onb_ser_type"
                            :items="ser_type"
                            class="pt-3"
                            style="font-size: 14px"
                            hide-details
                            dense
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-autocomplete
                            v-model="lOnbOtherServiceDet.vendorsupplier_cat_id"
                            :items="vendorSupplierCategoryList"
                            item-text="vendorsupplier_cat"
                            item-value="vendorsupplier_cat_id"
                            label="Vendor Category"
                            hide-details=
                            dense
                            clearable
                            style="font-size: 14px"
                            clear-icon="mdi-close-circle-outline"
                            @input="loadVendorSupplierSubCategoryList(lOnbOtherServiceDet)"
                            @change="clearVendorSupplierSubCatDropdown()"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 class="pt-4">
                            <v-autocomplete
                            v-model="lOnbOtherServiceDet.vendorsupplier_sub_cat_id"
                            :items="vendorSupplierSubCategoryList"
                            item-text="vendorsupplier_sub_cat"
                            item-value="vendorsupplier_sub_cat_id"
                            label="Vendor Sub-Category"
                            hide-details
                            dense
                            clearable
                            style="font-size: 14px"
                            clear-icon="mdi-close-circle-outline"
                            @input="loadVendorSupplierList(lOnbOtherServiceDet)"
                            @change="clearVendorSupplierDropdown()"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-autocomplete
                            v-model="lOnbOtherServiceDet.vendorsupplier_id"
                            :items="vendorSupplierList"
                            item-text="vendorsupplier_name"
                            item-value="vendorsupplier_id"
                            label="Vendor Name"
                            hide-details
                            dense
                            clearable
                            style="font-size: 14px"
                            clear-icon="mdi-close-circle-outline"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6>
                            <v-autocomplete
                            v-model="lOnbOtherServiceDet.onb_responsible_pair_id"
                            label="Responsibility"
                            item-value="emp_id"
                            item-text="disp_short_name"
                            :items="responsibilityEmpList"
                            style="font-size: 14px"
                            hide-details
                            small-chips
                            deletable-chips
                            clearable
                            dense
                            multiple
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-dialog ref="otherServicePlanEndDt"
                            persistent v-model="otherServicePlanEndDt"
                            max-width="290px"
                            :return-value.sync="lOnbOtherServiceDet.onb_plan_end_dt"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Plan End Date"
                                v-model="lOnbOtherServiceDet.onb_plan_end_dt"
                                append-icon="mdi-calendar-today"
                                readonly clearable
                                hide-details
                                style="font-size: 14px"
                                v-on="on"
                                required
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lOnbOtherServiceDet.onb_plan_end_dt" scrollable
                              first-day-of-week="1"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text @click="otherServicePlanEndDt = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.otherServicePlanEndDt.save(lOnbOtherServiceDet.onb_plan_end_dt)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs4>
                            <v-dialog ref="otherServiceActualEndDt"
                            persistent v-model="otherServiceActualEndDt"
                            max-width="290px"
                            :return-value.sync="lOnbOtherServiceDet.onb_actual_end_dt"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Actual End Date"
                                v-model="lOnbOtherServiceDet.onb_actual_end_dt"
                                append-icon="mdi-calendar-today"
                                readonly clearable
                                hide-details
                                style="font-size: 14px"
                                v-on="on"
                                required
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lOnbOtherServiceDet.onb_actual_end_dt" scrollable
                              first-day-of-week="1"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text @click="otherServiceActualEndDt = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.otherServiceActualEndDt.save(lOnbOtherServiceDet.onb_actual_end_dt)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs4>
                            <v-autocomplete
                            v-model="lOnbOtherServiceDet.onb_status"
                            :items="status_list"
                            label="Status"
                            hide-details
                            style="font-size: 14px"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lOnbOtherServiceDet.onb_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 9. Import Voice of customer from config -->
        <v-dialog v-model="showListOfVoiceofCustDet" persistent scrollable max-width="600px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Select Voice of Customer
              <v-spacer></v-spacer>
              <v-btn icon small @click="showListOfVoiceofCustDet = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-data-table
              v-model="selected"
              show-select
              :headers="voiceofCustDetHeadList"
              :items="voiceOfCustDetList"
              hide-default-footer
              disable-sort
              disable-pagination
              dense
              item-key="mi_voice_of_cust_id"
              class="elevation-1 importtableth importtabletd"
              style="font-size: 14px"
              :mobile-break-point="0">
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="importToVoiceOfCust(selected)">Import to Voice of Customer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 10. Add or update Voice of customer -->
        <v-dialog v-model="showVoice" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveVoiceofCustChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-3 py-2">
                    {{lVoice.action ? handy.startWithUpper(lVoice.action) : ''}} Voice of Customer
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lVoice.mi_voice_of_cust"
                        label="Voice of Customer Questions"
                        hide-details
                        maxlength="200"
                        style="font-size: 14px"
                        :disabled="lVoice.action === 'update' && lVoice.mi_voice_of_customer_id != null"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lVoice.mi_voice_of_cust_remarks"
                        label="Remarks if any?"
                        hide-details
                        maxlength="250"
                        style="font-size: 14px"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showVoice = false">Cancel</v-btn>
                    <v-btn type="submit" :disabled="disableSubmitButton" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 11. View Voice of Customer History -->
        <v-dialog v-model="showVoiceOfCustHistory" persistent max-width="800px">
          <v-card flat class="pa-0">
            <v-card-title style="font-size: 17px" class="pb-0">
              Voice of Customer History Details
              <v-spacer></v-spacer>
              <v-btn icon small @click="showVoiceOfCustHistory = false"><v-icon> mdi-close </v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md class="pt-3 px-0">
                <v-layout row wrap>
                  <v-flex xs12 class="uniformchipinfo">
                    <v-layout row wrap>
                      <v-flex xs8>
                        <div class="caption white--text">Voice Of Customer Description: </div>
                        <div class="white--text font-weight-bold">{{voiceOfCustBasicDet.mi_voice_of_cust}}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="caption white--text">Source: </div>
                        <div class="white--text font-weight-bold">{{voiceOfCustBasicDet.source}}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="uniformchipinfo">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <div class="caption white--text font-weight-bold">Remarks: </div>
                        <div class="white--text">{{voiceOfCustBasicDet.mi_voice_of_cust_remarks}}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout pt-1>
                  <v-flex xs11 pt-2>
                    <div class="subtitle black--text font-weight-bold">
                      History Details
                    </div>
                  </v-flex>
                  <v-flex xs1 pt-2>
                    <v-btn icon small v-if="config.IS_EDITED_BY_USER" :disabled="disableSubmitButton" @click="preparecreateVoiceOfCustHistory()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap pt-1>
                  <v-card-text class="ma-0 pa-0">
                    <v-data-table
                    :headers="voiceOfCustHistHeader"
                    :items="voiceOfCustHistoryList"
                    hide-default-header
                    hide-default-footer
                    fixed-header
                    class="elevation-3"
                    :mobile-breakpoint="0"
                    disable-pagination
                    dense
                    height="200px"
                    >
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[1].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 350px; text-align: left">{{headers[4].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: left">{{headers[5].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                          <td style="text-align:center; font-size: 12px"> {{ props.item.start_dt ? handy.formatDBDate(props.item.start_dt) : '-' }} </td>
                          <td style="text-align:left; font-size: 12px"> {{ props.item.created_by_name  }} </td>
                          <td style="text-align:left; font-size: 12px"> {{ props.item.remarks }} </td>
                          <td style="text-align:center; font-size: 12px">
                            <v-menu
                            :close-on-content-click="false"
                            top right class="mt-0">
                            <template v-slot:activator="{ on }">
                              <v-btn icon small v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <!-- list of menuitems -->
                            <v-list class="py-0">
                              <!-- menu with submenus of status -->
                              <v-list-item @click="prepareUpdateVoiceOfCustHistory(props.item)">
                                <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                                <v-list-item-title>Edit</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="deleteVoiceOfCustHistory(props.item)">
                                <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                                <v-list-item-title>Delete</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu> </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 12. Add or update or delete Voice of Customer History -->
        <v-dialog v-model="createVoiceOfCustHistory" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveVoiceOfCustHistory(lVoiceOfCustHistory.action)">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                    {{lVoiceOfCustHistory.action === 'create-voice-cust-hist' ? 'Create' : 'Update'}} Voice Of Customer History
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="createVoiceOfCustHistory = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-dialog ref="voiceOfCustStartDate"
                        persistent v-model="voiceOfCustStartDate"
                        max-width="290px"
                        :return-value.sync="lVoiceOfCustHistory.start_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Start Date"
                            v-model="lVoiceOfCustHistory.start_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lVoiceOfCustHistory.start_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="voiceOfCustStartDate = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.voiceOfCustStartDate.save(lVoiceOfCustHistory.start_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lVoiceOfCustHistory.remarks"
                        label="Add remarks if any"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 13. Import Customer Expectations from config -->
        <v-dialog v-model="showListOfCustExpectDet" persistent scrollable max-width="700px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Select Customer Expectation
              <v-spacer></v-spacer>
              <v-btn icon small @click="showListOfCustExpectDet = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-data-table
              v-model="selected"
              show-select
              :headers="custExpectDetHeadList"
              :items="custExpectDetList"
              hide-default-footer
              disable-sort
              disable-pagination
              dense
              item-key="mi_cust_expect_id"
              class="elevation-1 importtableth importtabletd"
              style="font-size: 14px"
              :mobile-break-point="0">
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="importToCustExpect(selected)">Import to Customer Expectations</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 14. Add or update Customer Expectations -->
        <v-dialog v-model="showCust" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveCustExpectChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-3 py-2">
                    {{lCust.action ? handy.startWithUpper(lCust.action) : ''}} Customer Expectations
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-autocomplete
                        v-model="lCust.category"
                        label="Category"
                        :items="categoryList"
                        hide-details
                        :rules="[rules.required]"
                        style="font-size: 14px"
                        :disabled="lCust.action === 'update' && lCust.mi_customer_expectation_id != null"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lCust.mi_cust_expectation"
                        label="Expectation Description"
                        hide-details
                        maxlength="200"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        :disabled="lCust.action === 'update' && lCust.mi_customer_expectation_id != null"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                        v-model="lCust.mi_freq_id"
                        :items="freqItem"
                        item-value="mi_freq_id"
                        item-text="mi_freq"
                        label="Frequency"
                        hide-details
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lCust.mi_cust_expect_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="250"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showCust = false">Cancel</v-btn>
                    <v-btn type="submit" :disabled="disableSubmitButton" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 15. View Customer Expectation History -->
        <v-dialog v-model="showCustExpectHistory" persistent max-width="800px">
          <v-card flat class="pa-0">
            <v-card-title style="font-size: 17px" class="pb-0">
              Customer Expectation History Details
              <v-spacer></v-spacer>
              <v-btn icon small @click="showCustExpectHistory = false"><v-icon> mdi-close </v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md class="pt-3 px-0">
                <v-layout row wrap>
                  <v-flex xs12 class="uniformchipinfo">
                    <v-layout row wrap>
                      <v-flex xs5>
                        <div class="caption white--text">Customer Expectation Description: </div>
                        <div class="white--text font-weight-bold">{{custExpectBasicDet.mi_cust_expectation}}</div>
                      </v-flex>
                      <v-flex xs3>
                        <div class="caption white--text">Source: </div>
                        <div class="white--text font-weight-bold">{{custExpectBasicDet.source}}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="caption white--text">Frequency: </div>
                        <div class="white--text font-weight-bold">{{custExpectBasicDet.mi_freq}}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="uniformchipinfo">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <div class="caption white--text font-weight-bold">Remarks: </div>
                        <div class="white--text">{{custExpectBasicDet.mi_cust_expect_remarks}}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout pt-1>
                  <v-flex xs11 pt-2>
                    <div class="subtitle black--text font-weight-bold">
                      History Details
                    </div>
                  </v-flex>
                  <v-flex xs1 pt-2>
                    <v-btn icon small v-if="config.IS_EDITED_BY_USER" :disabled="disableSubmitButton" @click="prepareCreateCustExpectHistory()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap pt-1>
                  <v-card-text class="ma-0 pa-0">
                    <v-data-table
                    :headers="custExpectHistHeader"
                    :items="custExpectHistoryList"
                    hide-default-header
                    hide-default-footer
                    fixed-header
                    class="elevation-3"
                    :mobile-breakpoint="0"
                    disable-pagination
                    dense
                    height="200px"
                    >
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[1].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 350px; text-align: left">{{headers[4].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: left">{{headers[5].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                          <td style="text-align:center; font-size: 12px"> {{ props.item.start_dt ? handy.formatDBDate(props.item.start_dt) : '-' }} </td>
                          <td style="text-align:left; font-size: 12px"> {{ props.item.created_by_name  }} </td>
                          <td style="text-align:left; font-size: 12px"> {{ props.item.remarks }} </td>
                          <td style="text-align:center; font-size: 12px">
                            <v-menu
                            :close-on-content-click="false"
                            top right class="mt-0">
                            <template v-slot:activator="{ on }">
                              <v-btn icon small v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <!-- list of menuitems -->
                            <v-list class="py-0">
                              <!-- menu with submenus of status -->
                              <v-list-item @click="prepareUpdateCustExpectHistory(props.item)">
                                <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                                <v-list-item-title>Edit</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="deleteCustExpectHistory(props.item)">
                                <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                                <v-list-item-title>Delete</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu> </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 16. Add or update or delete Customer Expectation History -->
        <v-dialog v-model="createCustExpectHistory" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveCustExpectHistory(lCustExpectHistory.action)">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                    {{lCustExpectHistory.action === 'create-cust-expect-hist' ? 'Create' : 'Update'}} Customer Expectation History
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="createCustExpectHistory = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-dialog ref="custExpectStartDate"
                        persistent v-model="custExpectStartDate"
                        max-width="290px"
                        :return-value.sync="lCustExpectHistory.start_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Start Date"
                            v-model="lCustExpectHistory.start_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lCustExpectHistory.start_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="custExpectStartDate = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.custExpectStartDate.save(lCustExpectHistory.start_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lCustExpectHistory.remarks"
                        label="Add remarks if any"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 17. Import Uniservice Commitment from config -->
        <v-dialog v-model="showListOfUniCommitDet" persistent scrollable max-width="700px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Select Uniservice Commitment
              <v-spacer></v-spacer>
              <v-btn icon small @click="showListOfUniCommitDet = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-data-table
              v-model="selected"
              show-select
              :headers="uniCommitDetHeadList"
              :items="uniCommitDetList"
              hide-default-footer
              disable-sort
              disable-pagination
              dense
              item-key="mi_uni_commit_id"
              class="elevation-1 importtableth importtabletd"
              style="font-size: 14px"
              :mobile-break-point="0">
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="importToUniCommit(selected)">Import to Uniservice Commitment</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 18. Add or update Uniservice Commitment -->
        <v-dialog v-model="showUniserviceCommit" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveUniCommitChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-3 py-2">
                    {{lUniCommit.action ? handy.startWithUpper(lUniCommit.action) : ''}} Uniservice Commitment
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-autocomplete
                        v-model="lUniCommit.category"
                        label="Category"
                        :items="categoryList"
                        hide-details
                        :rules="[rules.required]"
                        style="font-size: 14px"
                        :disabled="lUniCommit.action === 'update' && lUniCommit.mi_uniservice_commit_id != null"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lUniCommit.mi_uni_commit"
                        label="Commitment Description"
                        hide-details
                        maxlength="200"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        :disabled="lUniCommit.action === 'update' && lUniCommit.mi_uniservice_commit_id != null"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                        v-model="lUniCommit.mi_freq_id"
                        :items="freqItem"
                        item-value="mi_freq_id"
                        item-text="mi_freq"
                        label="Frequency"
                        hide-details
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lUniCommit.mi_uni_commit_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        style="font-size: 14px"
                        maxlength="250"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showUniserviceCommit = false">Cancel</v-btn>
                    <v-btn type="submit" :disabled="disableSubmitButton" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 19. View Uniservice Commitment History -->
        <v-dialog v-model="showUniCommitHistory" persistent max-width="800px">
          <v-card flat class="pa-0">
            <v-card-title style="font-size: 17px" class="pb-0">
              Uniservice Commitment History Details
              <v-spacer></v-spacer>
              <v-btn icon small @click="showUniCommitHistory = false"><v-icon> mdi-close </v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md class="pt-3 px-0">
                <v-layout row wrap>
                  <v-flex xs12 class="uniformchipinfo">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <div class="caption white--text">Category: </div>
                        <div class="white--text font-weight-bold">{{uniCommitBasicDet.category}}</div>
                      </v-flex>
                      <v-flex xs6>
                        <div class="caption white--text">Source: </div>
                        <div class="white--text font-weight-bold">{{uniCommitBasicDet.source}}</div>
                      </v-flex>
                      <v-flex xs6>
                        <div class="caption white--text">Frequency: </div>
                        <div class="white--text font-weight-bold">{{uniCommitBasicDet.mi_freq}}</div>
                      </v-flex>
                      <v-flex xs6>
                        <div class="caption white--text">Uniservice Commitment Description: </div>
                        <div class="white--text font-weight-bold">{{uniCommitBasicDet.mi_uni_commit}}</div>
                      </v-flex>
                      <v-flex xs12>
                        <div class="font-weight-bold caption white--text">Remarks: </div>
                        <div class="white--text">{{uniCommitBasicDet.mi_uni_commit_remarks}}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout pt-1>
                  <v-flex xs11 pt-2>
                    <div class="subtitle black--text font-weight-bold">
                      History Details
                    </div>
                  </v-flex>
                  <v-flex xs1 pt-2>
                    <v-btn icon small v-if="config.IS_EDITED_BY_USER" :disabled="disableSubmitButton" @click="prepareCreateUniCommitHistory()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap pt-1>
                  <v-card-text class="ma-0 pa-0">
                    <v-data-table
                    :headers="uniCommitHistHeader"
                    :items="uniCommitHistoryList"
                    hide-default-header
                    hide-default-footer
                    fixed-header
                    class="elevation-3"
                    :mobile-breakpoint="0"
                    disable-pagination
                    dense
                    height="200px"
                    >
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[1].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 350px; text-align: left">{{headers[4].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: left">{{headers[5].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                          <td style="text-align:center; font-size: 12px"> {{ props.item.start_dt ? handy.formatDBDate(props.item.start_dt) : '-' }} </td>
                          <td style="text-align:left; font-size: 12px"> {{ props.item.created_by_name  }} </td>
                          <td style="text-align:left; font-size: 12px"> {{ props.item.remarks }} </td>
                          <td style="text-align:center; font-size: 12px">
                            <v-menu
                            :close-on-content-click="false"
                            top right class="mt-0">
                            <template v-slot:activator="{ on }">
                              <v-btn icon small v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <!-- list of menuitems -->
                            <v-list class="py-0">
                              <!-- menu with submenus of status -->
                              <v-list-item @click="prepareUpdateUniCommitHistory(props.item)">
                                <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                                <v-list-item-title>Edit</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="deleteUniCommitHistory(props.item)">
                                <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                                <v-list-item-title>Delete</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu> </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 20. Add or update or delete Uniservice Commitment History -->
        <v-dialog v-model="createUniCommitHistory" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveUniCommitHistory(lUniCommitHistory.action)">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                    {{lUniCommitHistory.action === 'create-uni-commit-hist' ? 'Create' : 'Update'}} Uniservice Commitment History
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="createUniCommitHistory = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-dialog ref="uniCommitStartDate"
                        persistent v-model="uniCommitStartDate"
                        max-width="290px"
                        :return-value.sync="lUniCommitHistory.start_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Start Date"
                            v-model="lUniCommitHistory.start_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lUniCommitHistory.start_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="uniCommitStartDate = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.uniCommitStartDate.save(lUniCommitHistory.start_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lUniCommitHistory.remarks"
                        label="Add remarks if any"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 21. Add/ Update Feedback/Snag audit action item details -->
        <v-dialog v-model="showSnagAuditAction" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lFormSnagAuditAction" @submit.prevent="saveSnagAuditActionDetChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-3 py-2">
                    {{lSnagAuditAction.action ? handy.startWithUpper(lSnagAuditAction.action) : ''}} Feedback/Snag Audit Action Item
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showSnagAuditAction = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs8>
                            <v-autocomplete
                            v-model="lSnagAuditAction.category"
                            label="Category"
                            :items="categoryList"
                            hide-details
                            :rules="[rules.required]"
                            style="font-size: 14px"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs4>
                            <v-autocomplete
                            v-model="lSnagAuditAction.snag_priority"
                            :items="priority_list"
                            label="Priority"
                            hide-details
                            style="font-size: 14px"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lSnagAuditAction.snag_des"
                        label="Snag Description"
                        hide-details
                        maxlength="200"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lSnagAuditAction.snag_action_des"
                        label="Action Item Description"
                        hide-details
                        maxlength="200"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 class="pt-2">
                        <v-autocomplete
                        v-model="lSnagAuditAction.responsible_pair_id"
                        label="Responsibility"
                        item-value="emp_id"
                        item-text="disp_short_name"
                        :items="responsibilityEmpList"
                        style="font-size: 14px"
                        hide-details
                        small-chips
                        deletable-chips
                        clearable
                        dense
                        multiple
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-dialog ref="snagAuditActionPlanEndDt"
                            persistent v-model="snagAuditActionPlanEndDt"
                            max-width="290px"
                            :return-value.sync="lSnagAuditAction.plan_end_dt"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Plan End Date"
                                v-model="lSnagAuditAction.plan_end_dt"
                                append-icon="mdi-calendar-today"
                                readonly clearable
                                hide-details
                                style="font-size: 14px"
                                v-on="on"
                                required
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lSnagAuditAction.plan_end_dt" scrollable
                              first-day-of-week="1"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text @click="snagAuditActionPlanEndDt = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.snagAuditActionPlanEndDt.save(lSnagAuditAction.plan_end_dt)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs4>
                            <v-dialog ref="snagAuditActionActualEndDt"
                            persistent v-model="snagAuditActionActualEndDt"
                            max-width="290px"
                            :return-value.sync="lSnagAuditAction.actual_end_dt"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Actual End Date"
                                v-model="lSnagAuditAction.actual_end_dt"
                                append-icon="mdi-calendar-today"
                                readonly clearable
                                hide-details
                                style="font-size: 14px"
                                :disabled="lSnagAuditAction.status !== 'Completed'"
                                v-on="on"
                                required
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lSnagAuditAction.actual_end_dt" scrollable
                              first-day-of-week="1"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text @click="snagAuditActionActualEndDt = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.snagAuditActionActualEndDt.save(lSnagAuditAction.actual_end_dt)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs4>
                            <v-autocomplete
                            v-model="lSnagAuditAction.status"
                            :items="status_list"
                            label="Status"
                            hide-details
                            style="font-size: 14px"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lSnagAuditAction.remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                  <v-btn class="ml-3" v-if="lAction === 'update' && config.IS_EDITED_BY_USER" @click="deleteSnagAuditActionDet(lSnagAuditAction)">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 22. View Feedback/Snag Audit Action item History -->
        <v-dialog v-model="showSnagAuditActionItemHistory" persistent max-width="800px">
          <v-card flat class="pa-0">
            <v-card-title style="font-size: 17px" class="pb-0">
              Feedback/Snag Audit Action Item History Details
              <v-spacer></v-spacer>
              <v-btn icon small @click="showSnagAuditActionItemHistory = false"><v-icon> mdi-close </v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md class="pt-3 px-0">
                <v-layout row wrap>
                  <v-flex xs12 class="uniformchipinfo">
                    <v-layout row wrap>
                      <v-flex xs4>
                        <div class="caption white--text">Category: </div>
                        <div class="white--text font-weight-bold">{{snagAuditBasicDet.category}}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="caption white--text">Priority: </div>
                        <div class="white--text font-weight-bold">{{snagAuditBasicDet.snag_priority}}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="caption white--text">Status: </div>
                        <div class="white--text font-weight-bold">{{snagAuditBasicDet.status}}</div>
                      </v-flex>
                      <v-flex xs12>
                        <div class="caption white--text">Snag Description: </div>
                        <div class="white--text font-weight-bold">{{snagAuditBasicDet.snag_des}}</div>
                      </v-flex>
                      <v-flex xs12>
                        <div class="caption white--text">Action Item Description: </div>
                        <div class="white--text font-weight-bold">{{snagAuditBasicDet.snag_action_des}}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout pt-1>
                  <v-flex xs11 pt-2>
                    <div class="subtitle black--text font-weight-bold">
                      History Details
                    </div>
                  </v-flex>
                  <v-flex xs1 pt-2>
                    <v-btn icon small v-if="config.IS_EDITED_BY_USER" :disabled="disableSubmitButton" @click="prepareCreateSnagAuditActionItemHistory()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap pt-1>
                  <v-card-text class="ma-0 pa-0">
                    <v-data-table
                    :headers="snagAuditActionItemHistHeader"
                    :items="snagAuditActionItemHistoryList"
                    hide-default-header
                    hide-default-footer
                    fixed-header
                    class="elevation-3"
                    :mobile-breakpoint="0"
                    disable-pagination
                    dense
                    height="200px"
                    >
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[1].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 350px; text-align: left">{{headers[4].text}}</th>
                            <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: left">{{headers[5].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                          <td style="text-align:center; font-size: 12px"> {{ props.item.start_dt ? handy.formatDBDate(props.item.start_dt) : '-' }} </td>
                          <td style="text-align:left; font-size: 12px"> {{ props.item.created_by_name  }} </td>
                          <td style="text-align:left; font-size: 12px"> {{ props.item.remarks }} </td>
                          <td style="text-align:center; font-size: 12px">
                            <v-menu
                            :close-on-content-click="false"
                            top right class="mt-0">
                            <template v-slot:activator="{ on }">
                              <v-btn icon small v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <!-- list of menuitems -->
                            <v-list class="py-0">
                              <!-- menu with submenus of status -->
                              <v-list-item @click="prepareUpdateSnagAuditActionItemHistory(props.item)">
                                <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                                <v-list-item-title>Edit</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="deleteSnagAuditActionItemHistory(props.item)">
                                <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                                <v-list-item-title>Delete</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu> </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 23. Add or update or delete Uniservice Commitment History -->
        <v-dialog v-model="createSnagAuditActionItemHistory" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveSnagAuditActionItemHistory(lSnagAuditActionItemHistory.action)">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                    {{lSnagAuditActionItemHistory.action === 'create-snag-hist' ? 'Create' : 'Update'}} Feedback/Snag Audit Action Item History
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="createSnagAuditActionItemHistory = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-dialog ref="snagHistStartDate"
                        persistent v-model="snagHistStartDate"
                        max-width="290px"
                        :return-value.sync="lSnagAuditActionItemHistory.start_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Start Date"
                            v-model="lSnagAuditActionItemHistory.start_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lSnagAuditActionItemHistory.start_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="snagHistStartDate = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.snagHistStartDate.save(lSnagAuditActionItemHistory.start_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lSnagAuditActionItemHistory.remarks"
                        label="Add remarks if any"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 24. Upload Documents -->
        <v-dialog v-model="showOnboardingDocUpload" persistent scrollable max-width="700px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Documents Upload
              <v-spacer></v-spacer>
              <v-btn icon small @click="showOnboardingDocUpload = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-flex xs12>
                <input style="display:none" type="file" ref="fileInput"
                accept=".xls, .eml, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lUploadDoc)"/>
                <v-btn icon @click="pickFile"><v-icon>mdi-attachment</v-icon></v-btn>
                <span v-if="lUploadDoc.files && lUploadDoc.files.filter(rec => rec.is_selected).length > 0">
                  <span v-for="(file, index) in lUploadDoc.files.filter(rec => rec.is_selected)" :key="index">
                    <v-chip style="font-size: 12px;" v-model="file.is_selected" @click:close="removeSelectedFile(file)" close>{{ file.file_name }}</v-chip>
                  </span>
                </span>
                <span v-else>Attachment if any<br /><span class="caption">(supports images, pdfs, docs and excels upto 20MB)</span></span>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                v-model="lUploadDoc.mi_doc_type"
                label="Doc Type"
                :items="doc_type_list"
                hide-details
                style="font-size: 14px"
                :rules="[rules.required]"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                v-model="lUploadDoc.mi_doc_remarks"
                label="Remarks"
                hide-details
                maxlength="250"
                style="font-size: 14px"
                :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="saveUploadedDocs()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 25. Basic Information of Commnunity -->
        <v-dialog v-model="showCommunityInfo" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-card>
                <v-card-title style="font-size: 17px" class="py-0 grey lighten-3">
                  Community Information
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showCommunityInfo = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pb-1 body-1">
                  <v-container grid-list-md class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <span class="caption grey--text">Community Id.</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.comm_id }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Community Name</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.comm_name }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Community Type</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.comm_type }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Community Address</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.address }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">No of Units</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.no_of_unit }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Customer Since</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.cust_since ? handy.formatDate(commBasicInformationList.cust_since) : ''}}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 26. Basic Information of Project -->
        <v-dialog v-model="showProjectInfo" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-card>
                <v-card-title style="font-size: 17px" class="py-0 grey lighten-3">
                  Project Information
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showProjectInfo = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pb-1 body-1">
                  <v-container grid-list-md class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Id.</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_id }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Name</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_name }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Type</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_type }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Status</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_status }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Manager</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.emp_name }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Start</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_start ? handy.formatDate(projBasicInformationList.proj_start) : '' }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 27. Basic information of Project Contract -->
        <v-dialog v-model="showProjectContractInfo" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-card>
                <v-card-title style="font-size: 17px" class="py-0 grey lighten-3">
                  Project Contract Information
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showProjectContractInfo = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pb-1 body-1">
                  <v-container grid-list-md class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-spacer></v-spacer>
                      </v-flex>
                      <v-flex xs6>
                        <v-btn small class="accent" @click="prepareViewProjContract(lOnboardReviewBase)">View Project Contract Detail</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Id.</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.proj_contract_base_id }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract HeadCount</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.head_count }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Status</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.status }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Version</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.version + '.0' }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Created By</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.update_by_name + ' on ' + handy.formatDate(projContractInformationList.updated_date) }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Value</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.contract_value_with_gst ? handy.formatCur(projContractInformationList.contract_value_with_gst) : '' }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 28. "Project Contract View" based on project_contract_base_id -->
        <v-dialog scrollable v-model="showContractViewAsPdf" max-width="900px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Project Contract Detail
              <v-spacer></v-spacer>
              <v-btn icon small @click="showContractViewAsPdf = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-flex xs12>
                <v-card flat>
                  <v-card-text class="pa-0">
                    <!-- 1st and 2nd view-->
                    <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-0' || attTab === 'tab-1'">
                      <v-layout row wrap>
                        <v-flex xs12 v-if="projContractView[0] && projContractView[0].length > 0 && projContractView[0][0].proj_contract_sub_category">
                          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                            <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;font-weight: semi-bold;">{{projContractView[0][0].heading}}</div>
                            <v-data-table
                            :headers="techHeaders"
                            hide-default-header
                            :items="projContractView[0]"
                            disable-sort
                            hide-default-footer
                            dense
                            disable-pagination>
                              <template v-slot:header="{ props: { headers } }">
                                <thead>
                                  <tr>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                  </tr>
                                </thead>
                              </template>
                              <template slot="item" slot-scope="props">
                                <tr>
                                  <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                  <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                  <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="background-color: #fff; font-family: Arial, Helvetica, sans-serif; color: #000;">
                                    <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[0].total_amount) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                            <v-flex xs12 v-if="attTab === 'tab-0'">
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="(mgmt, i) in projContractView[1]" :key="i">
                                    <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; font-family: Arial, Helvetica, sans-serif; color: #09391f;">
                                    <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[0].before_gst) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="gst in projContractView[2]" :key="gst.gst_amt">
                                    <td style="font-size: 12px; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(gst.tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; font-family: Arial, Helvetica, sans-serif; color: #fff;">
                                    <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[0][0].heading.substring(10, projContractView[0][0].heading.length)}} Grand Total with GST</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[0].gst_tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                        <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[3] && projContractView[3].length > 0 && projContractView[3][0].staff_role">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">{{projContractView[3][0].heading}}</div>
                          <v-flex xs12>
                            <v-flex xs12 v-for="(cat, i) in categoryListForContractView" :key="i" v-if="projContractView[3].filter(rec => rec.role_cat === cat).length > 0">
                              <div style="padding: 4px 0px; font-size: 12px; font-family: Arial, Helvetica, sans-serif; background-color: #71c1f5; color: #000; text-align: center;">
                                {{handy.startWithUpper(cat.toLowerCase())}}
                              </div>
                              <v-data-table
                              :headers="manpowerHeaders"
                              hide-default-header
                              :items="projContractView[3].filter(rec => rec.role_cat === cat)"
                              hide-default-footer
                              disable-sort
                              dense
                              disable-pagination
                              >
                                <template v-slot:header="{ props: { headers } }">
                                  <thead>
                                    <tr>
                                      <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                                      <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                      <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                                      <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                                      <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                                    </tr>
                                  </thead>
                                </template>
                                <template slot="item" slot-scope="props">
                                  <tr>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[3].total_amount) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                            <v-flex xs12 v-if="attTab === 'tab-0'">
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;" v-for="mgmt in projContractView[4]" :key="mgmt.Mgmt_fee_per">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.Mgmt_fee_per}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; color:#09391f;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[3].before_gst) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;" v-for="gst in projContractView[5]" :key="gst.gst_amt">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(gst.tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; color: #fff;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[3][0].heading.substring(8, projContractView[3][0].heading.length)}} Grand Total with GST</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[3].gst_tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[6] && projContractView[6].length && projContractView[6][0].staff_role">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[6][0].heading}}</div>
                          <v-flex xs12 v-if="projContractView[6].filter(rec => rec.role_cat === 'SAFTY/SECURITY').length > 0">
                            <v-divider class="black"></v-divider>
                            <v-data-table
                            :headers="manpowerHeaders"
                            hide-default-header
                            :items="projContractView[6]"
                            disable-sort
                            hide-default-footer
                            dense
                            disable-pagination
                            >
                              <template v-slot:header="{ props: { headers } }">
                                <thead>
                                  <tr>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                                  </tr>
                                </thead>
                              </template>
                              <template slot="item" slot-scope="props">
                                <tr>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[6].total_amount) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                            <v-flex xs12 v-if="attTab === 'tab-0'">
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;" v-for="mgmt in projContractView[7]" :key="mgmt.Mgmt_fee_per">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; width: 100px;">Management fees ({{mgmt.Mgmt_fee_per}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; color:#09391f;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[6].before_gst) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;" v-for="gst in projContractView[8]" :key="gst.gst_amt">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(gst.tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; color: #fff;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[6][0].heading.substring(8, projContractView[6][0].heading.length)}} Grand Total with GST</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[6].gst_tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[9] && projContractView[9].length && projContractView[9][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[9][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[9]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[9].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[10]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[9].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[11]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[9][0].heading.substring(21, projContractView[9][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[9].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[12] && projContractView[12].length && projContractView[12][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[12][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[12]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[12].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[13]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[12].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[14]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[12][0].heading.substring(13, projContractView[12][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[12].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[15] && projContractView[15].length && projContractView[15][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[15][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[15]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[15].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[16]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[15].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[17]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[15][0].heading.substring(13, projContractView[15][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[15].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[18] && projContractView[18].length && projContractView[18][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[18][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[18]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[18].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[19]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[18].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[20]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[18][0].heading.substring(5, projContractView[18][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[18].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[21] && projContractView[21].length && projContractView[21][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[21][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[21]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[21].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[22]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[21].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[23]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[21][0].heading.substring(20, projContractView[21][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[21].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[24] && projContractView[24].length && projContractView[24][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[24][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[24]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[24].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[25]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[24].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[26]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[24][0].heading.substring(9, projContractView[24][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[24].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td colspan="3"></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <!-- SUMMARY -->
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
                          <table width="100%" cellpadding="0" cellspacing="0">
                            <tbody>
                              <tr style="color: #000;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].sub_total) }}
                                </td>
                                <td></td>
                              </tr>
                              <tr style="color: #000;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
                                </td>
                                <td></td>
                              </tr>
                              <tr style="background-color: #93f0cf; color:#09391f;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].before_gst) }}
                                </td>
                                <td></td>
                              </tr>
                              <tr style="color: #000;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].tax_amt) }}
                                </td>
                                <td></td>
                              </tr>
                              <tr style="background-color: #44cb82; color: #fff;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].after_gst) }}
                                </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 v-else>
                        <div>
                          No Data Available
                        </div>
                      </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- 3rd view -->
                    <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-2'">
                      <v-layout row wrap>
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
                          <v-data-table
                          :headers="manpowerHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[0].concat(projContractView[3]).concat(projContractView[6]).concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
                          hide-default-footer
                          dense
                          disable-pagination>
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr v-if="props.item.staff_role || props.item.proj_contract_sub_category">
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role ? props.item.staff_role : props.item.proj_contract_sub_category }}</td>
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count ? props.item.head_count : 1 }}</td>
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc ? props.item.amt_per_hc : props.item.amount }}</td>
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt ? props.item.total_hc_amt : props.item.amount }}</td>
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <div style="page-break-after:always; clear:both"></div>
                        <v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
                          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                            <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].sub_total) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].after_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                        <v-flex xs12 v-else>
                          <div>
                            No Data Available
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- 4th view -->
                    <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-3'">
                      <v-layout row wrap>
                        <v-flex xs12 v-if="(projContractView[3] && projContractView[3].length > 0  && projContractView[3][0].staff_role) || (projContractView[6] && projContractView[6].length > 0 && projContractView[6][0].staff_role)">
                          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                            <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">MANPOWER</div>
                            <v-data-table
                            :headers="manpowerHeaders"
                            hide-default-header
                            disable-sort
                            :items="projContractView[3].concat(projContractView[6])"
                            hide-default-footer
                            dense
                            disable-pagination>
                              <template v-slot:header="{ props: { headers } }">
                                <thead>
                                  <tr>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                                  </tr>
                                </thead>
                              </template>
                              <template slot="item" slot-scope="props">
                                <tr>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].total_amount ? projContractView[3].total_amount : 0) + (projContractView[6].total_amount ? projContractView[6].total_amount : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].mgmt ? projContractView[3].mgmt : 0) + (projContractView[6].mgmt ? projContractView[6].mgmt : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; color:#09391f;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].before_gst ? projContractView[3].before_gst : 0) + (projContractView[6].before_gst ? projContractView[6].before_gst : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].tax_amt ? projContractView[3].tax_amt : 0) + (projContractView[6].tax_amt ? projContractView[6].tax_amt : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; color: #fff;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].gst_tax_amt ? projContractView[3].gst_tax_amt : 0) + (projContractView[6].gst_tax_amt ? projContractView[6].gst_tax_amt : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                        <v-flex xs12 style="padding-top: 6px;" v-if="projContractView[28] && projContractView[28][0].total_amount">
                          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                            <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">SERVICE</div>
                            <v-data-table
                            :headers="techHeaders"
                            hide-default-header
                            disable-sort
                            :items="projContractView[0].concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
                            hide-default-footer
                            dense
                            disable-pagination>
                              <template v-slot:header="{ props: { headers } }">
                                <thead>
                                  <tr>
                                    <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                    <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                    <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                  </tr>
                                </thead>
                              </template>
                              <template slot="item" slot-scope="props">
                                <tr>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28][0].total_amount) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28][0].mgmt_fee) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; color:#09391f;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28][0].before_gst) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28].tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; color: #fff;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28][0].total_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-flex xs12>
                <v-tabs v-model="attTab" show-arrows>
                  <v-tab v-for="(attitem, n) in viewTabItems" :key="n" :href="`#tab-${n}`" @click="changeView(attitem)">
                    {{attitem}}
                  </v-tab>
                </v-tabs>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 29. "Onboarding Review View" for selected mi_base_id -->
        <v-dialog v-model="showOnboardingReviewView" persistent max-width="1200px" grid-list-md>
          <v-card>
            <v-card-title fixed class="py-0 grey lighten-2">
              <div style="font-size: 17px" class="font-weight-bold">Onboarding Review - Detailed View</div>
              <v-spacer></v-spacer>
              <v-btn icon @click="showOnboardingReviewView = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pt-3 pa-3">
              <v-card>
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Onboarding Planner Details</div>
                </v-card-title>
                <v-card-text class="pa-2">
                  <v-card :class="i > 0 ? 'mt-2' : ''" v-for="(cat, i) in onboardCat" :key="i">
                    <v-card-title style="background-color: #71c1f5;" class="body-2 font-weight-bold py-1">
                      {{cat}}
                    </v-card-title>
                    <v-data-table
                    :headers="onboardPlannerReviewItemViewHeader"
                    :items="onboardPlannerReviewItemList.filter(rec => rec.onb_planner_cat === cat)"
                    hide-default-footer
                    hide-default-header
                    disable-pagination
                    dense
                    class="elevation-1"
                    :mobile-breakpoint="0">
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: center;">{{headers[0].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 275px; text-align: left;">{{headers[1].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 130px; text-align: left;">{{headers[2].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[3].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[4].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[5].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: left;">{{headers[6].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 200px; text-align: left;">{{headers[7].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr :class="(props.item.onb_status === 'Not Started' || props.item.onb_status === 'In-Progress' || props.item.onb_status === 'On-Hold') ? 'red--text' : ''" >
                          <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                          <td style="font-size: 12px;">{{ props.item.onb_planner_sub_cat }}</td>
                          <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDate(props.item.onb_plan_end_dt) : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDate(props.item.onb_actual_end_dt) : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_onb_complete ? 'Yes' : 'No' }}</td>
                          <td style="font-size: 12px;">{{ props.item.onb_status }}</td>
                          <td style="font-size: 12px;">{{ props.item.onb_remarks ? props.item.onb_remarks : '-' }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Manpower and Service Engagement</div>
                </v-card-title>
                <v-card-text class="pa-2">
                  <v-card class="mt-0">
                    <v-card-title style="background-color: #71c1f5;" class="body-2 font-weight-bold py-1">
                      <div>Manpower Hiring and Deployment (in-house)</div>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-data-table
                      :headers="manpowerDepInHouseItemViewHeader"
                      :items="manpowerDepInHouseItemList"
                      hide-default-footer
                      disable-pagination
                      dense
                      class="elevation-1"
                      :mobile-breakpoint="0">
                        <template slot="item" slot-scope="props">
                          <tr :class="(props.item.onb_status === 'Not Started' || props.item.onb_status === 'In-Progress' || props.item.onb_status === 'On-Hold') ? 'red--text' : ''" >
                            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_contract_hc }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_deployed_hc }}</td>
                            <td style="font-size: 12px;" class="text-right">{{ props.item.onb_budget_cost ? handy.formatCur(props.item.onb_budget_cost) : '-' }}</td>
                            <td style="font-size: 12px;" class="text-right">{{ props.item.onb_actual_cost ? handy.formatCur(props.item.onb_actual_cost) : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDBDate(props.item.onb_plan_end_dt) : '-' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDBDate(props.item.onb_actual_end_dt) : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_status ? props.item.onb_status : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_remarks ? props.item.onb_remarks : '-' }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <v-card class="mt-2">
                    <v-card-title style="background-color: #71c1f5;" class="body-2 font-weight-bold py-1">
                      <div class="body-2 font-weight-bold">Vendor Engagement (Outsourced Services)</div>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-data-table
                      :headers="manpowerDepOutsourceItemViewHeader"
                      :items="manpowerDepOutsourceItemList"
                      hide-default-footer
                      disable-pagination
                      dense
                      class="elevation-1"
                      :mobile-breakpoint="0">
                        <template slot="item" slot-scope="props">
                          <tr :class="(props.item.onb_status === 'Not Started' || props.item.onb_status === 'In-Progress' || props.item.onb_status === 'On-Hold') ? 'red--text' : ''" >
                            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_contract_hc ? props.item.onb_contract_hc : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-'}}</td>
                            <td style="font-size: 12px;" class="text-right">{{ props.item.onb_budget_cost ? handy.formatCur(props.item.onb_budget_cost) : '-' }}</td>
                            <td style="font-size: 12px;" class="text-right">{{ props.item.onb_actual_cost ? handy.formatCur(props.item.onb_actual_cost) : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDBDate(props.item.onb_plan_end_dt) : '-' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDBDate(props.item.onb_actual_end_dt) : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_status ? props.item.onb_status : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_remarks ? props.item.onb_remarks : '-' }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <v-card class="mt-2">
                    <v-card-title style="background-color: #71c1f5;" class="body-2 font-weight-bold py-1">
                      <div class="body-2 font-weight-bold">Other Services Engagement</div>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-data-table
                      :headers="otherServiceEngageItemViewHeader"
                      :items="otherServiceEngageItemList"
                      hide-default-footer
                      disable-pagination
                      dense
                      class="elevation-1"
                      :mobile-breakpoint="0">
                        <template slot="item" slot-scope="props">
                          <tr :class="(props.item.onb_status === 'Not Started' || props.item.onb_status === 'In-Progress' || props.item.onb_status === 'On-Hold') ? 'red--text' : ''" >
                            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 12px;">{{ props.item.ser_role }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_ser_type ? props.item.onb_ser_type : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-' }}</td>
                            <td style="font-size: 12px;" class="text-right">{{ props.item.onb_budget ? handy.formatCur(props.item.onb_budget) : '-' }}</td>
                            <td style="font-size: 12px;" class="text-right">{{ props.item.onb_deployed_cost ? handy.formatCur(props.item.onb_deployed_cost) : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDBDate(props.item.onb_plan_end_dt) : '-' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDBDate(props.item.onb_actual_end_dt) : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_status ? props.item.onb_status : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_remarks ? props.item.onb_remarks : '-' }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Voice Of Customer</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="voiceOfCustItemViewHeader"
                  :items="onbVoiceOfCustWithHitoryForViewList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 320px; text-align: left;">{{headers[1].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 80px; text-align: left;">{{headers[2].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[3].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[4].text}}</th>
                      </tr>
                    </thead>
                  </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_voice_of_cust }}</td>
                        <td style="font-size: 12px;">{{ props.item.source }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_voice_of_cust_remarks }}</td>
                        <td style="font-size: 12px;">
                          <div v-for="(text, index) in props.item.hist_remark.split('\n')" :key="index">
                            {{ text }}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Customer Expectations</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="custExpectItemViewHeader"
                  :items="onbCustExpectWithHitoryForViewList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[1].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 140px; text-align: left;">{{headers[2].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 80px; text-align: left;">{{headers[3].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 80px; text-align: left;">{{headers[4].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[5].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[6].text}}</th>
                      </tr>
                    </thead>
                  </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.category }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_cust_expectation }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_freq }}</td>
                        <td style="font-size: 12px;">{{ props.item.source }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_cust_expect_remarks }}</td>
                        <td style="font-size: 12px;">
                          <div v-for="(text, index) in props.item.hist_remark.split('\n')" :key="index">
                            {{ text }}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Uniservice Commitment</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="uniCommitItemViewHeader"
                  :items="onbUniCommitmentWithHitoryForViewList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[1].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 140px; text-align: left;">{{headers[2].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 80px; text-align: left;">{{headers[3].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 80px; text-align: left;">{{headers[4].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[5].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[6].text}}</th>
                      </tr>
                    </thead>
                  </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.category }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_uni_commit }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_freq }}</td>
                        <td style="font-size: 12px;">{{ props.item.source }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_uni_commit_remarks }}</td>
                        <td style="font-size: 12px;">
                          <div v-for="(text, index) in props.item.hist_remark.split('\n')" :key="index">
                            {{ text }}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Feedback/Snag Audit Action Item Details</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="onbSnagAuditActionItemViewHeader"
                  :items="onbSnagAuditActionItemWithHitoryForViewList"
                  hide-default-footer
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.category }}</td>
                        <td style="font-size: 12px;">{{ props.item.snag_des }}</td>
                        <td style="font-size: 12px;">{{ props.item.snag_action_des }}</td>
                        <td style="font-size: 12px;">{{ props.item.snag_priority }}</td>
                        <td style="font-size: 12px;">{{ props.item.status }}</td>
                        <td style="font-size: 12px;">{{ props.item.disp_short_name }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.plan_end_dt ? handy.formatDBDate(props.item.plan_end_dt) : '-' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.actual_end_dt ? handy.formatDBDate(props.item.actual_end_dt) : '-' }}</td>
                        <td style="font-size: 12px;">{{ props.item.source }}</td>
                        <td style="font-size: 12px;">{{ props.item.remarks }}</td>
                        <td style="font-size: 12px;">
                          <div v-for="(text, index) in props.item.hist_remark.split('\n')" :key="index">
                            {{ text }}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Documents</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="docItemHeader"
                  :items="docItemList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[1].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 170px; text-align: center;">{{headers[2].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[3].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[4].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 350px; text-align: left;">{{headers[5].text}}</th>
                      </tr>
                    </thead>
                  </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.file_name }}</td>
                        <td style="text-align:center;"><a :href="handy.loadImg(props.item.file_url)" download style="text-decoration: none;">
                          <v-icon small class="info--text">mdi-download</v-icon>
                        </a></td>
                        <td style="font-size: 12px;">{{ props.item.mi_doc_type }}</td>
                        <td style="font-size: 12px;">{{ props.item.source }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_doc_remarks }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 30. Onboarding Planner Review Validation Summary -->
        <v-dialog v-model="showOnbPlannerValidationSummary" persistent max-width="1200px" grid-list-md>
          <v-card>
            <v-card-title class="py-0 grey lighten-2">
              <div style="font-size: 17px" class="font-weight-bold">Onboarding Planner Validation Summary</div>
              <v-spacer></v-spacer>
              <v-btn icon @click="showOnbPlannerValidationSummary = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pt-3 pa-3">
              <v-card>
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Onboarding Planner Details</div>
                </v-card-title>
                <v-card-text class="pa-2">
                  <v-card :class="i > 0 ? 'mt-2' : ''" v-for="(cat, i) in onboardCat" :key="i">
                    <v-card-title style="background-color: #71c1f5;" class="body-2 font-weight-bold py-1">
                      {{cat}}
                    </v-card-title>
                    <v-data-table
                    :headers="onboardPlannerValidationSummaryHeader"
                    :items="onboardPlannerValidationStatusList.filter(rec => rec.onb_planner_cat === cat)"
                    hide-default-footer
                    hide-default-header
                    disable-pagination
                    dense
                    class="elevation-1"
                    :mobile-breakpoint="0">
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: center;">{{headers[0].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 275px; text-align: left;">{{headers[1].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 130px; text-align: left;">{{headers[2].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[3].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[4].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[5].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: left;">{{headers[6].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[7].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                          <td style="font-size: 12px;">{{ props.item.onb_planner_sub_cat }}</td>
                          <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.onb_plan_end_dt ? handy.formatDate(props.item.onb_plan_end_dt) : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.onb_actual_end_dt ? handy.formatDate(props.item.onb_actual_end_dt) : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_onb_complete ? 'Yes' : 'No' }}</td>
                          <td style="font-size: 12px;">{{ props.item.onb_status }}</td>
                          <td style="text-align:center;">
                            <v-icon v-if="props.item.is_valid === 'Valid'" small class="success--text">mdi-check</v-icon>
                            <v-icon v-if="props.item.is_valid === 'Invalid'" small class="red--text">mdi-close</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- snack bar for reporting -->
        <v-snackbar :color="sbarCol" v-model="sbar"
        :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      lAction: 'view',
      config: config,
      handy: handy,
      rules: handy.rules,
      panel: [0,1,2,3],
      searchText: '',
      // Summary View Declarations
      lOnboardReviewSummaryList: [],
      onboardSummaryListHeader: [
        { text: 'SNo.', value: '', class: 'uniformchipinfo white--text' },
        { text: 'Current Department', value: 'current_dept', class: 'uniformchipinfo white--text' },
        { text: 'Review Version No.', value: 'version_no', class: 'uniformchipinfo white--text' },
        { text: 'Project Contract Version', value: 'project_contract_version', class: 'uniformchipinfo white--text' },
        { text: 'Project Contract Value', value: 'contract_amt_with_tax', class: 'uniformchipinfo white--text' }
      ],
      dlgDate: false,
      isClosedProject: false,
      selTab: 0,
      beingSaved: false,
      source_var: 'Onboarding',
      doc_type_list: ['Agreement', 'LOI', 'Salary-Breakup', 'Audit-Report', 'Checklist', 'MoM', 'MC e-Mail', 'Proposal/ Quote', 'Project Exit Docs', 'Other'],
      status_list: ['Not Started', 'In-Progress', 'On-Hold', 'Completed', 'Not Applicable', 'Cancelled'],
      onboardReviewProjList: [],
      isShowOnlyPendingItems: true,
      // Onboarding Review Detail Declarations
      lOnboardReviewBase: [],
      commList: [],
      projList: [],
      lVersion: null,
      projContractList: [],
      disableSubmitButton: false,
      versionList: [],
      onboardPlannerReviewItemList: [],
      onboardPlannerReviewItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Description', value: 'onb_planner_sub_cat', class: 'grey lighten-4 primary--text', width: '275px', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'grey lighten-4 primary--text', width: '140px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Onb Task?', value: 'mi_is_onb_complete', class: 'grey lighten-4 primary--text', width: '100px', align: 'center', sortable: false },
        { text: 'Recover Asset?', value: 'mi_is_asset_recoverable', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class: 'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Remark', value: 'onb_remarks', class: 'grey lighten-4 primary--text', width: '200px', sortable: false }
      ],
      onboardPlannerReviewItemViewHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Description', value: 'onb_planner_sub_cat', class: 'grey lighten-4 primary--text', width: '275px', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'grey lighten-4 primary--text', width: '140px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Onb Task?', value: 'mi_is_onb_complete', class: 'grey lighten-4 primary--text', width: '100px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class: 'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Remark', value: 'onb_remarks', class: 'grey lighten-4 primary--text', width: '200px', sortable: false }
      ],
      onboardCat: [],
      manpowerDepItemList: [],
      manpowerDepInHouseItemList: [],
      manpowerDepInHouseItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Role Name', value: 'staff_role', class: 'grey lighten-4 primary--text', width: '200px' },
        { text: 'Head Count', value: 'onb_contract_hc', class: 'grey lighten-4 primary--text', width: '150px', align: 'center', sortable: false },
        { text: 'Dep Count', value: 'onb_deployed_hc', class: 'grey lighten-4 primary--text', width: '200px', sortable: false },
        { text: 'Budget CTC', value: 'onb_budget_cost', class:'grey lighten-4 primary--text', width: '120px', align: 'right', sortable: false },
        { text: 'Actual TH', value: 'onb_actual_cost', class:'grey lighten-4 primary--text', width: '120px', align: 'right', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class:'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class:'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class:'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class:'grey lighten-4 primary--text', width: '120px' },
        { text: 'Remark', value: 'onb_remarks', class:'grey lighten-4 primary--text', width: '250px', sortable: false }
      ],
      manpowerDepInHouseItemViewHeader: [
        { text: 'SNo.', value: '', class: 'teal lighten-4 pr-0', align: 'left', width: '55px', sortable: false },
        { text: 'Role Name', value: 'staff_role', class: 'teal lighten-4', width: '200px' },
        { text: 'Head Count', value: 'onb_contract_hc', class: 'teal lighten-4', width: '150px', align: 'center', sortable: false },
        { text: 'Deployed HC', value: 'onb_deployed_hc', class: 'teal lighten-4', width: '200px', sortable: false },
        { text: 'Budget CTC', value: 'onb_budget_cost', class: 'teal lighten-4', width: '120px', align: 'right', sortable: false },
        { text: 'Actual TH', value: 'onb_actual_cost', class: 'teal lighten-4', width: '120px', align: 'right', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'teal lighten-4', width: '120px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class: 'teal lighten-4', width: '140px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class: 'teal lighten-4', width: '140px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class: 'teal lighten-4', width: '100px' },
        { text: 'Remark', value: 'onb_remarks', class: 'teal lighten-4', width: '250px', sortable: false }
      ],
      manpowerDepOutsourceItemList: [],
      manpowerDepOutsourceItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Role Name', value: 'staff_role', class: 'grey lighten-4 primary--text', width: '200px' },
        { text: 'Head Count', value: 'onb_contract_hc', class: 'grey lighten-4 primary--text', width: '150px', align: 'center', sortable: false },
        { text: 'Vendor Name', value: 'vendorsupplier_name', class: 'grey lighten-4 primary--text', width: '200px' },
        { text: 'Budget Cost', value: 'onb_budget_cost', class:'grey lighten-4 primary--text', width: '120px', align: 'right', sortable: false },
        { text: 'Actual Cost', value: 'onb_actual_cost', class:'grey lighten-4 primary--text', width: '120px', align: 'right', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class:'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class:'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class:'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class:'grey lighten-4 primary--text', width: '100px' },
        { text: 'Remark', value: 'onb_remarks', class:'grey lighten-4 primary--text', width: '250px', sortable: false }
      ],
      manpowerDepOutsourceItemViewHeader: [
        { text: 'SNo.', value: '', class: 'teal lighten-4 pr-0', align: 'left', width: '55px', sortable: false },
        { text: 'Role Name', value: 'staff_role', class: 'teal lighten-4', width: '200px' },
        { text: 'Head Count', value: 'onb_contract_hc', class: 'teal lighten-4', width: '150px', align: 'center', sortable: false },
        { text: 'Vendor Name', value: 'vendorsupplier_name', class: 'teal lighten-4', width: '200px' },
        { text: 'Budget Cost', value: 'onb_budget_cost', class: 'teal lighten-4', width: '120px', align: 'right', sortable: false },
        { text: 'Actual Cost', value: 'onb_actual_cost', class: 'teal lighten-4', width: '120px', align: 'right', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'teal lighten-4', width: '120px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class: 'teal lighten-4', width: '140px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class: 'teal lighten-4', width: '140px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class: 'teal lighten-4', width: '100px' },
        { text: 'Remark', value: 'onb_remarks', class: 'teal lighten-4', width: '250px', sortable: false }
      ],
      otherServiceEngageItemList: [],
      otherServiceEngageItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Role Name', value: 'ser_role', class: 'grey lighten-4 primary--text', width: '200px' },
        { text: 'Service Model', value: 'onb_ser_type', class: 'grey lighten-4 primary--text', align: 'center', width: '150px', sortable: false },
        { text: 'Vendor Name', value: 'vendorsupplier_name', class: 'grey lighten-4 primary--text', width: '200px' },
        { text: 'Budget', value: 'onb_budget', class:'grey lighten-4 primary--text', width: '120px', align: 'right', sortable: false },
        { text: 'Act.Cost', value: 'onb_deployed_cost', class:'grey lighten-4 primary--text', width: '120px', align: 'right', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class:'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class:'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class:'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class:'grey lighten-4 primary--text', width: '100px'},
        { text: 'Remark', value: 'onb_remarks', class:'grey lighten-4 primary--text', width: '250px', sortable: false }
      ],
      otherServiceEngageItemViewHeader: [
        { text: 'SNo.', value: '', class: 'teal lighten-4 pr-0', align: 'left', width: '55px', sortable: false },
        { text: 'Role Name', value: 'ser_role', class: 'teal lighten-4', width: '200px' },
        { text: 'Service Model', value: 'onb_ser_type', class: 'teal lighten-4', width: '150px', align: 'center', sortable: false },
        { text: 'Vendor Name', value: 'vendorsupplier_name', class: 'teal lighten-4', width: '200px' },
        { text: 'Budget', value: 'onb_budget', class: 'teal lighten-4', width: '120px', align: 'right', sortable: false },
        { text: 'Act.Cost', value: 'onb_deployed_cost', class: 'teal lighten-4', width: '120px', align: 'right', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'teal lighten-4', width: '120px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class: 'teal lighten-4', width: '140px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class: 'teal lighten-4', width: '140px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class: 'teal lighten-4', width: '100px'},
        { text: 'Remark', value: 'onb_remarks', class: 'teal lighten-4', width: '250px', sortable: false }
      ],
      voiceOfCustItemList: [],
      voiceOfCustItemHeader: [
        { text: 'Sno', value: 'sno', sortable: false },
        { text: 'Description', value: 'mi_voice_of_cust', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Remark', value: 'mi_voice_of_cust_remarks', sortable: false },
        { text: 'History', value: '', sortable: false }
      ],
      voiceOfCustItemViewHeader: [
        { text: 'Sno', value: 'sno', sortable: false },
        { text: 'Description', value: 'mi_voice_of_cust', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Remark', value: 'mi_voice_of_cust_remarks', sortable: false },
        { text: 'History', value: 'hist_remark', sortable: false }
      ],
      custExpectItemList: [],
      custExpectItemHeader: [
        { text: 'Sno', value: 'sno' },
        { text: 'Category', value: 'category' },
        { text: 'Expectation Description', value: 'mi_cust_expectation' },
        { text: 'Frequency', value: 'mi_freq', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Remark', value: 'mi_cust_expect_remarks' },
        { text: 'History', value: '', sortable: false }
      ],
      custExpectItemViewHeader: [
        { text: 'Sno', value: 'sno' },
        { text: 'Category', value: 'category' },
        { text: 'Expectation Desc', value: 'mi_cust_expectation' },
        { text: 'Frequency', value: 'mi_freq', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Remark', value: 'mi_cust_expect_remarks' },
        { text: 'History', value: 'hist_remark' }
      ],
      uniCommitItemList: [],
      uniCommitItemHeader: [
        { text: 'Sno', value: 'sno' },
        { text: 'Category', value: 'category' },
        { text: 'Commitment Description', value: 'mi_uni_commit' },
        { text: 'Frequency', value: 'mi_freq', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Remark', value: 'mi_uni_commit_remarks' },
        { text: 'History', value: '' }
      ],
      uniCommitItemViewHeader: [
        { text: 'Sno', value: 'sno' },
        { text: 'Category', value: 'category' },
        { text: 'Commitment Desc', value: 'mi_uni_commit' },
        { text: 'Frequency', value: 'mi_freq', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Remark', value: 'mi_uni_commit_remarks' },
        { text: 'History', value: 'hist_remark' }
      ],
      docItemList:[],
      docItemHeader:[
        { text: 'Sno', value: 'sno' },
        { text: 'Document File Name', value: 'mi_sales_sub_cat' },
        { text: 'Download', value: '', sortable: false },
        { text: 'Doc Type', value: 'mi_doc_type', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Remark', value: 'sales_review_doc_remarks' }
      ],
      // import onboarding planner
      lOnbPlannerImportResponsible: [],
      onboardingPlannerDetList: [],
      selected: [],
      showListOfOnboardingPlannerDet: false,
      onboardingPlannerDetHeadList: [
        { text: 'Category', value: 'mi_onb_cat', class: 'primary--text', width: '200px', sortable: false },
        { text: 'Information/ Questionnaire', value: 'mi_onb_sub_cat', width: '200px', class: 'primary--text', sortable: false },
        { text: 'Prior Days ', value: 'prior_days', class: 'primary--text', width: '90px', align: 'center', sortable: false  },
        { text: 'Onb Task?', value: 'mi_is_onb_complete', class: 'primary--text', width: '90px', align: 'center', sortable: false  },
        { text: 'Recover Asset?', value: 'mi_is_asset_recoverable', class: 'primary--text', width: '120px', align: 'center', sortable: false }
      ],
      beingSaved: false,
      lOnbPlanner: [],
      showOnbPlanner: false,
      planEndDt: false,
      actualEndDt: false,
      responsibilityEmpList: [],
      approvedContractList: [],
      tempContractList: [],
      showContractImportSection: false,
      // voice of cust
      lVoice: [],
      showVoice: false,
      voiceOfCustDetList: [],
      showListOfVoiceofCustDet: false,
      voiceofCustDetHeadList: [
        { text: 'Questionnaire', value: 'mi_voice_of_cust', class: 'primary--text', sortable: false }
      ],
      // cust expect
      custExpectDetList: [],
      custExpectDetHeadList: [
        { text: 'Category', value: 'category', class: 'primary--text', sortable: false },
        { text: 'Customer Expectations Description', value: 'mi_cust_expect', class: 'primary--text', sortable: false },
        { text: 'Frequency', value: 'mi_freq', class: 'primary--text', sortable: false }
      ],
      showListOfCustExpectDet: false,
      lCust: [],
      showCust: false,
      freqItem: [],
      // unit commit
      showUniserviceCommit: false,
      lUniCommit: [],
      uniCommitDetList: [],
      showListOfUniCommitDet: false,
      uniCommitDetHeadList: [
        { text: 'Category', value: 'category', class: 'primary--text', sortable: false },
        { text: 'Uniservice Commitment Description', value: 'mi_uni_commit', class: 'primary--text', sortable: false },
        { text: 'Frequency', value: 'mi_freq', class: 'primary--text', sortable: false }
      ],
      // upload document
      showOnboardingDocUpload: false,
      lUploadDoc: [],
      showCommunityInfo: false,
      showProjectInfo: false,
      showProjectContractInfo: false,
      commBasicInformationList: [],
      projBasicInformationList: [],
      projContractInformationList: [],
      showContractViewAsPdf: false,
      techHeaders: [
        { text: 'Category' , value: 'proj_contract_sub_category' },
        { text: 'Total' , value: 'amount', sortable: false },
        { text: 'Comments' , value: 'comments', sortable: false }
      ],
      manpowerHeaders: [
        { text: 'Category' , value: 'staff_role' },
        { text: 'No of Person' , value: 'head_count' },
        { text: 'Rate/Person' , value: 'amt_per_hc' },
        { text: 'Total' , value: 'total_hc_amt' },
        { text: 'Comments' , value: 'comments' }
      ],
      projContractView: [],
      viewTabItems: ['Proposal breakup', 'end-to-end proposal', 'compressed view', 'M&S view'],
      attTab: 'tab-0',
      categoryList: ['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS'],
      categoryListForContractView: ['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'OTHERS'],
      lOnbManpowerInhouseDet: [],
      showOnbManDepInhouseDet: false,
      inhousePlanEndDt: false,
      inhouseActualEndDt: false,
      lOnbManpowerOutsourceDet: [],
      showOnbManDepOutsourceDet: false,
      outsourcePlanEndDt: false,
      outsourceActualEndDt: false,
      lOnbOtherServiceDet: [],
      showOnbOtherServiceDet: false,
      otherServicePlanEndDt: false,
      otherServiceActualEndDt: false,
      ser_type: ['In-house', 'Outsource'],
      showOnboardingReviewView: false,
      // Other service remaining det import
      selected: [],
      otherServiceImportEntireList: [],
      otherServiceImportRemainingList: [],
      otherServiceFilter: [],
      showListOfOnbOtherServiceImport: false,
      onbOtherServiceRemainingDetHeader: [
        { text: 'Category', value: 'proj_contract_category', class: 'grey lighten-4 primary--text', width: '200px' },
        { text: 'Service Name', value: 'proj_contract_sub_category', class: 'grey lighten-4 primary--text', width: '200px' },
        { text: 'Budget', value: 'amount', class:'grey lighten-4 primary--text', width: '120px', align: 'right', sortable: false }
      ],
      otherServiceRemainingId: [],
      // Add history for Voice of Cust, Cust Expect, Uni Commit
      showVoiceOfCustHistory: false,
      voiceOfCustBasicDet: [],
      lVoiceOfCustHistory: {},
      createVoiceOfCustHistory: false,
      voiceOfCustStartDate: false,
      custExpectStartDate: false,
      uniCommitStartDate: false,
      voiceOfCustHistHeader: [
        { text: 'S.No' , value: '' },
        { text: 'Start Date' , value: 'start_dt' },
        { text: 'Created By' , value: 'created_by_name' },
        { text: 'Updated By' , value: 'updated_by_name' },
        { text: 'Remarks' , value: 'remarks' },
        { text: 'Menu' , value: 'action' }
      ],
      voiceOfCustHistoryList: [],
      showCustExpectHistory: false,
      custExpectBasicDet: [],
      lCustExpectHistory: {},
      createCustExpectHistory: false,
      custExpectHistoryList: [],
      custExpectHistHeader: [
        { text: 'S.No' , value: '' },
        { text: 'Start Date' , value: 'start_dt' },
        { text: 'Created By' , value: 'created_by_name' },
        { text: 'Updated By' , value: 'updated_by_name' },
        { text: 'Remarks' , value: 'remarks' },
        { text: 'Menu' , value: 'action' }
      ],
      showUniCommitHistory: false,
      createUniCommitHistory: false,
      lUniCommitHistory: {},
      uniCommitBasicDet: [],
      uniCommitHistHeader: [
        { text: 'S.No' , value: '' },
        { text: 'Start Date' , value: 'start_dt' },
        { text: 'Created By' , value: 'created_by_name' },
        { text: 'Updated By' , value: 'updated_by_name' },
        { text: 'Remarks' , value: 'remarks' },
        { text: 'Menu' , value: 'action' }
      ],
      uniCommitHistoryList: [],
      // Mandep Remaining det import
      onbContractMandepImportEntireList: [],
      onbMandepImportRemainingList: [],
      onbMandepFilter: [],
      showListOfOnbMandepImport: false,
      onbMandepRemainingDetHeader: [
        { text: 'Category', value: 'role_cat', class: 'grey lighten-4 primary--text', width: '120px' },
        { text: 'Role Name', value: 'staff_role', class: 'grey lighten-4 primary--text', width: '150px' },
        { text: 'Head Count', value: 'head_count', class: 'grey lighten-4 primary--text', width: '100px', align: 'center', sortable: false },
        { text: 'Amount Per HC', value: 'amt_per_hc', class:'grey lighten-4 primary--text', width: '120px', align: 'right', sortable: false },
        { text: 'Type', value: 'onb_staff_type', class:'grey lighten-4 primary--text', width: '80px', align: 'center', sortable: false }
      ],
      onbMandepRemainingId: [],
      showOnbPlannerValidationSummary: false,
      isOndReviewValid: false,
      onboardPlannerValidationStatusList: [],
      onboardPlannerValidationSummaryHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Description', value: 'onb_planner_sub_cat', class: 'grey lighten-4 primary--text', width: '275px', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'grey lighten-4 primary--text', width: '140px', sortable: false },
        { text: 'Plan End Date', value: 'onb_plan_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'onb_actual_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Onb Task?', value: 'mi_is_onb_complete', class: 'grey lighten-4 primary--text', width: '100px', align: 'center', sortable: false },
        { text: 'Status', value: 'onb_status', class: 'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Is Valid?', value: '', class: 'grey lighten-4 primary--text', width: '100px', sortable: false }
      ],
      onbVoiceOfCustWithHitoryForViewList: [],
      onbCustExpectWithHitoryForViewList: [],
      onbUniCommitmentWithHitoryForViewList: [],
      // Snag audit Declarations
      priority_list: ['Low', 'Medium', 'High', 'Very-High', 'Critical'],
      onbSnagAuditActionItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Category', value: 'category', class: 'grey lighten-4 primary--text', width: '150px' },
        { text: 'Snag Description', value: 'snag_des', class: 'grey lighten-4 primary--text', width: '200px', align: 'left', sortable: false },
        { text: 'Action Item', value: 'snag_action_des', class: 'grey lighten-4 primary--text', width: '200px' },
        { text: 'Priority', value: 'snag_priority', class:'grey lighten-4 primary--text', width: '100px', align: 'left', sortable: false },
        { text: 'Status', value: 'status', class:'grey lighten-4 primary--text', width: '100px' },
        { text: 'Responsibility', value: 'disp_short_name', class:'grey lighten-4 primary--text', width: '150px', sortable: false },
        { text: 'Plan End Date', value: 'plan_end_dt', class:'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'actual_end_dt', class:'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Source', value: 'source', class:'grey lighten-4 primary--text', width: '100px' },
        { text: 'Remark', value: 'remarks', class:'grey lighten-4 primary--text', width: '250px', sortable: false },
        { text: 'History', value: '', class:'grey lighten-4 primary--text', width: '55px', sortable: false }
      ],
      onbSnagAuditActionItemViewHeader: [
        { text: 'SNo.', value: '', class: 'pr-0', align: 'left', class: 'teal lighten-4', width: '55px', sortable: false },
        { text: 'Category', value: 'category', class: 'teal lighten-4', width: '150px' },
        { text: 'Snag Description', value: 'snag_des', class: 'teal lighten-4', width: '170px', sortable: false },
        { text: 'Action Item', value: 'snag_action_des', class: 'teal lighten-4', width: '170px' },
        { text: 'Priority', value: 'snag_priority', class: 'teal lighten-4', width: '100px', sortable: false },
        { text: 'Status', value: 'status', class: 'teal lighten-4', width: '100px' },
        { text: 'Responsibility', value: 'disp_short_name', class: 'teal lighten-4', width: '120px', sortable: false },
        { text: 'Plan End Date', value: 'plan_end_dt', class: 'teal lighten-4', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'actual_end_dt', class: 'teal lighten-4', width: '120px', align: 'center', sortable: false },
        { text: 'Source', value: 'source', class: 'teal lighten-4', width: '100px' },
        { text: 'Remark', value: 'remarks', class: 'teal lighten-4', width: '200px', sortable: false },
        { text: 'History', value: 'hist_remark', class: 'teal lighten-4', width: '250px', sortable: false }
      ],
      snagAuditActionItemList: [],
      lSnagAuditAction: [],
      showSnagAuditAction: false,
      snagAuditActionPlanEndDt: false,
      snagAuditActionActualEndDt: false,
      showSnagAuditActionItemHistory: false,
      snagAuditBasicDet: [],
      snagAuditActionItemHistHeader: [
        { text: 'S.No' , value: '' },
        { text: 'Start Date' , value: 'start_dt' },
        { text: 'Created By' , value: 'created_by_name' },
        { text: 'Updated By' , value: 'updated_by_name' },
        { text: 'Remarks' , value: 'remarks' },
        { text: 'Menu' , value: 'action' }
      ],
      snagAuditActionItemHistoryList: [],
      lSnagAuditActionItemHistory: [],
      createSnagAuditActionItemHistory: false,
      snagHistStartDate: false,
      onbSnagAuditActionItemWithHitoryForViewList: [],
      // Vendor Supplier Declarations
      vendorSupplierCategoryList: [],
      vendorSupplierSubCategoryList: [],
      vendorSupplierList: [],

    }
  },
  created () {
    this.loadOnboardReviewSummaryList()
    this.loadResponsibiltyEmpList()
    this.isShowOnlyPendingItems = false
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    searchProjectTitle (curRec) {
      if (curRec && curRec.length > 1) {
        var tmpVar = this.onboardReviewProjList.filter(rec => rec.toLowerCase().includes(curRec.toLowerCase()))
        if (tmpVar.length > 0) {
          this.onboardReviewProjList = []
          this.onboardReviewProjList = tmpVar
        } else {
          this.onboardReviewProjList = []
        }
      } else {
        this.loadOnboardReviewSummaryList()
      }
    },
    showClosedProjects () {
      this.isClosedProject = !this.isClosedProject
      this.loadOnboardReviewSummaryList()
    },
    loadOnlyPendingItems () {
      this.isShowOnlyPendingItems = !this.isShowOnlyPendingItems
      this.loadOnboardingReviewDetails()
    },
    loadOnboardReviewSummaryList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          is_closed_project: this.isClosedProject
        }
      }
      this.lOnboardReviewSummaryList = []
      this.axios.get(config.API_URL + '/getListOfOnboardReviewSummaryBaseByVendorId/', qry)
      .then(response => {
        this.lOnboardReviewSummaryList = response.data
        this.onboardReviewProjList = handy.unique(this.lOnboardReviewSummaryList.map(rec => rec.proj_name))
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdate (curRec) {
      this.showContractImportSection = false
      this.lOnboardReviewBase = Object.assign({}, curRec)
      this.loadCommunity()
      this.lOnboardReviewBase.comm_pair = { comm_id: curRec.comm_id, comm_name: curRec.comm_name }
      this.lOnboardReviewBase.proj_pair = { proj_id: curRec.proj_id, proj_name: curRec.proj_name }
      this.lVersion = this.lOnboardReviewBase.mi_base_id
      this.lOnboardReviewBase.new_proj_contract_base_id = null
      this.lOnboardReviewBase.on_boarding_date = curRec.on_boarding_date ? handy.formatDBDate(curRec.on_boarding_date) : ''
      this.loadProjectBasedOnCommId (this.lOnboardReviewBase)
      this.loadProjectContractBasedOnMIBaseID (this.lOnboardReviewBase)
      setTimeout(() => {
        this.showAnyNewContractVersionApprovedBasedonProjId()
      }, 500)
      this.loadOnboardingReviewDetails()
      this.importContractManpowerDetOnLoad()
      this.importContractServiceDetOnLoad()
      setTimeout(() => {
        this.loadOnboardingReviewDetails()
      }, 500)
      this.lAction = 'update'
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.commList = []
      this.projList = []
      this.axios.get(config.API_URL + '/getProjectCommList/', qry)
      .then(response => {
        this.commList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjectBasedOnCommId (curComm) {
      if (curComm.comm_pair && curComm.comm_pair.comm_id) {
        var qry = {
          params: {
            comm_id: curComm.comm_pair.comm_id
          }
        }
        this.projList = []
        this.axios.get(config.API_URL + '/getProjectListBasedOnCommId/', qry)
        .then(response => {
          this.projList = response.data
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadProjectContractBasedOnMIBaseID (curReview) {
      var qry = {
        params: {
          mi_base_id: curReview.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.projContractList = []
      this.axios.get(config.API_URL + '/getProjContractVerFromContractMapTableBasedOnMiBaseId/', qry)
      .then(response => {
        this.projContractList = response.data
        if(this.projContractList.length > 0) {
          this.lOnboardReviewBase.proj_contract_base_id = this.projContractList[0].proj_contract_base_id
        }
        // this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    clearVendorSupplierSubCatDropdown () {
      this.lOnbManpowerOutsourceDet.vendorsupplier_sub_cat_id = ''
      this.lOnbManpowerOutsourceDet.vendorsupplier_id = ''
    },
    clearVendorSupplierDropdown () {
      this.lOnbManpowerOutsourceDet.vendorsupplier_id = ''
    },
    loadReviewVersionBasedonMIBaseId () {
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.versionList = []
      this.axios.get(config.API_URL + '/getReviewVersionBasedonMIBaseId/', qry)
      .then(response => {
        this.versionList = response.data
        this.versionList.forEach(rec => {
          if (rec.mi_base_id === this.lOnboardReviewBase.mi_base_id) {
            // disable submit to onboard button if the status other than Onboarding
            if (rec.version.includes('Sales') || rec.version.includes('Operation') || rec.version.includes('Closed')) {
              this.disableSubmitButton = true
            } else {
              this.disableSubmitButton = false
            }
          }
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadOnboardingReviewDetails () {
      var path = require('path')
      this.loadReviewVersionBasedonMIBaseId()
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          showOnlyPendingItems: this.isShowOnlyPendingItems,
          vendor_id: config.VENDOR_ID
        }
      }
      this.loadOnboardingPlannerReviewItemList()
      this.loadOnboardingManDepItemList()
      this.loadOnboardingOtherServiceEngageItemList()

      this.voiceOfCustItemList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewVoiceofCustDetailsBasedonMIBaseId/', qry)
      .then(response => {
        this.voiceOfCustItemList = response.data
      })

      this.custExpectItemList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewCustExpectDetailsBasedonMIBaseId/', qry)
      .then(response => {
        this.custExpectItemList = response.data
      })

      this.uniCommitItemList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewUniCommitDetailsBasedonMIBaseId/', qry)
      .then(response => {
        this.uniCommitItemList = response.data
      })

      this.snagAuditActionItemList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewSnagAuditActionDetailsBasedonMIBaseId/', qry)
      .then(response => {
        this.snagAuditActionItemList = response.data
      })

      this.docItemList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewDocUploadsBasedonMIBaseId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          this.docItemList.push({
            file_url: rec.file_url,
            file_name: rec.file_url ? path.basename(rec.file_url) : '',
            is_selected: true,
            is_changed: false,
            mi_doc_type: rec.mi_doc_type,
            source: rec.source,
            mi_doc_remarks: rec.mi_doc_remarks,
            mi_doc_upload_id: rec.mi_doc_upload_id,
            mi_base_id: this.lOnboardReviewBase.mi_base_id
          })
        })
      })
    },
    loadOnboardingPlannerReviewItemList() {
      // this method call is required to load project contract versions in the list. Otherwise approved project will be shown again for import.
      this.loadReviewVersionBasedonMIBaseId()
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          showOnlyPendingItems: this.isShowOnlyPendingItems,
          vendor_id: config.VENDOR_ID
        }
      }
      this.onboardPlannerReviewItemList = []
      this.axios.get(config.API_URL + '/getListOfOnboardingPlannerDetailsBasedonMIBaseId/', qry)
      .then(response => {
        this.onboardPlannerReviewItemList = response.data
        this.onboardCat = handy.unique(this.onboardPlannerReviewItemList.map(rec => rec.onb_planner_cat))
      })
    },
    loadOnboardingManDepItemList() {
      // this method call is required to load project contract versions in the list. Otherwise approved project will be shown again for import.
      this.loadReviewVersionBasedonMIBaseId()
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          showOnlyPendingItems: this.isShowOnlyPendingItems,
          vendor_id: config.VENDOR_ID
        }
      }
      this.manpowerDepItemList = []
      this.manpowerDepInHouseItemList = []
      this.manpowerDepOutsourceItemList = []
      this.axios.get(config.API_URL + '/getListOfMandepContractDetBasedonContractBaseIdandMIBaseId/', qry)
      .then(response => {
        this.manpowerDepItemList = response.data
        this.manpowerDepInHouseItemList = response.data.filter(rec => rec.is_os === 0)
        this.manpowerDepOutsourceItemList = response.data.filter(rec => rec.is_os === 1)
      })
    },
    loadOnboardingOtherServiceEngageItemList() {
      // this method call is required to load project contract versions in the list. Otherwise approved project will be shown again for import.
      this.loadReviewVersionBasedonMIBaseId()
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          showOnlyPendingItems: this.isShowOnlyPendingItems,
          vendor_id: config.VENDOR_ID
        }
      }
      this.otherServiceEngageItemList = []
      this.axios.get(config.API_URL + '/getListOfotherServiceEngageByMIBaseIDandContractBaseID/', qry)
      .then(response => {
        this.otherServiceEngageItemList = response.data
      })
    },
    saveOnboardReviewBaseChanges (action) {
      if (this.lOnboardReviewBase.on_boarding_date) {
        this.axios.post(config.API_URL + '/miSaveOnboardReviewBase/base-update', this.lOnboardReviewBase)
        .then(response => {
          this.msg('Saved Successfully', 1)
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please Select Onboarding Date', 0)
      }
    },
    importContractManpowerDetOnLoad () {
      // This import will be executed on the first time load of the Onboarding Review item when click from summary list.
      // First get the list of records in the sv_mi_onboard_mandep_det table based on mi_base_id, proj_contract_base_id by comparing with sv_mi_base_contract_map.
      // if no record found import the contract details to sv_mi_onboard_mandep_det else do not import.
      // Because contract details are already imported and the records are already present in the table.
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      // Get contract has mandep details and if the rows > 0 then insert into sv_mi_onboard_mandep_det
      this.axios.get(config.API_URL + '/getmiIsContractHasManpowerDetails/', qry)
      .then(respmandep => {
        if (respmandep.data.length > 0) {
          // import for sv_mi_onboard_mandep_det
          this.axios.get(config.API_URL + '/getIsMandepDetImportedFromProjectContract/', qry)
          .then(resp => {
            if (resp.data.length === 0) {
              // up in db
              this.lOnboardReviewBase.vendor_id = config.VENDOR_ID
              this.lOnboardReviewBase.updated_by = config.EMP_ID
              this.lOnboardReviewBase.source = this.source_var // Onboarding
              this.beingSaved = true
              this.axios.post(config.API_URL + '/miOnbOprReviewContractMandepDetImport/import-on-load', this.lOnboardReviewBase)
              .then(response => {
                if (response.data === 'success') {
                  this.msg('Contract Manpower and Service Details Imported Successfully', 1)
                  this.loadOnboardingManDepItemList()
                  this.beingSaved = false
                } else {
                  this.msg(response.data, 0)
                }
              })
            }
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.beingSaved = false
    },
    importContractServiceDetOnLoad () {
      // This import will be executed on the first time load of the Onboarding Review item when click from summary list.
      // First get the list of records in the sv_mi_onboard_service table based on mi_base_id, proj_contract_base_id by comparing with sv_mi_base_contract_map.
      // if no record found import the contract details to sv_mi_onboard_service else do not import.
      // Because contract details are already imported and the records are already present in the table.
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      // Get list of service added in the contract details and if the rows > 0 then insert into sv_mi_onboard_mandep_det
      this.axios.get(config.API_URL + '/getmiIsContractHasServiceDetails/', qry)
      .then(respser => {
        if (respser.data.length > 0) {
          // import for sv_mi_onboard_service
          this.axios.get(config.API_URL + '/getIsMIServiceImportedFromProjectContract/', qry)
          .then(resp => {
            if (resp.data.length === 0) {
              // up in db
              this.lOnboardReviewBase.vendor_id = config.VENDOR_ID
              this.lOnboardReviewBase.updated_by = config.EMP_ID
              this.lOnboardReviewBase.source = this.source_var // Onboarding
              this.beingSaved = true
              this.axios.post(config.API_URL + '/miOnbOprReviewContractServiceImport/import-on-load', this.lOnboardReviewBase)
              .then(response => {
                if (response.data === 'success') {
                  this.msg('Contract Manpower and Service Details Imported Successfully', 1)
                  this.loadOnboardingOtherServiceEngageItemList()
                  this.beingSaved = false
                } else {
                  this.msg(response.data, 0)
                }
              })
            }
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.beingSaved = false
    },
    prepareOnboardingPlannerImport (filterList) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.onb_planner_sub_cat_id) : null
        }
      }
      this.lOnbPlannerImportResponsible.onb_responsible_import_pair_id = []
      this.onboardingPlannerDetList = []
      this.axios.get(config.API_URL + '/getListOfOnboardPlannerBasedOnGivenBaseIdExceptAlreadyImported/', qry)
      .then(response => {
        this.onboardingPlannerDetList = response.data
        this.onboardingPlannerDetList.forEach(rec => {
          rec.mi_is_onb_complete = rec.mi_is_onb_complete ? 'Yes' : 'No'
          rec.mi_is_asset_recoverable = rec.mi_is_asset_recoverable ? 'Yes' : 'No'
        })
        this.selected = []
        this.showListOfOnboardingPlannerDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToOnboardingPlanner (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.forEach(rec => {
          let date = new Date(handy.formatDBDate(this.lOnboardReviewBase.on_boarding_date))
          rec.onb_plan_end_dt = handy.formatDBDate(date.setDate(date.getDate() - rec.prior_days))
        })
        curSelectedArray.push({
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID,
          import_responsible_ids: this.lOnbPlannerImportResponsible.onb_responsible_import_pair_id,
          source: this.source_var // Onboarding
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/miOnboardingPlannerDetailsImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfOnboardingPlannerDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadOnboardingReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select item from the list to import.', 0)
      }
    },
    prepareCreateOnboardingPlanner () {
      this.lOnbPlanner = {
        onb_planner_cat: '',
        onb_planner_sub_cat: '',
        onb_remarks: '',
        onb_source: 'Onboarding',
        onb_status: 'Not Started',
        mi_base_id: this.lOnboardReviewBase.mi_base_id,
        onb_responsible_pair_id: [],
        mi_is_onb_complete: false,
        action: 'create'
      }
      this.showOnbPlanner = true
    },
    saveOnboardingPlannerChanges () {
      if (this.lOnbPlanner.onb_planner_cat && this.lOnbPlanner.onb_planner_sub_cat) {
        this.lOnbPlanner.vendor_id = config.VENDOR_ID
        this.lOnbPlanner.mi_is_asset_recoverable = this.lOnbPlanner.mi_is_asset_recoverable ? this.lOnbPlanner.mi_is_asset_recoverable : 0
        this.lOnbPlanner.onb_responsible = this.lOnbPlanner.onb_responsible_pair_id ? this.lOnbPlanner.onb_responsible_pair_id.map(rec => rec.emp_id) : null
        this.axios.post(config.API_URL + '/miOnboardingPlannerDet/', this.lOnbPlanner)
        .then(response => {
          this.loadOnboardingReviewDetails()
          this.msg('Saved Successfully', 1)
          this.showOnbPlanner = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory field', 0)
      }
    },
    prepareOnbPlannerUpdate (curRec) {
      if (curRec.emp_id) {
        curRec.onb_responsible_pair_id = []
        curRec.emp_id.split(",").forEach(rec => {
          curRec.onb_responsible_pair_id.push(parseInt(rec))
        })
      }
      this.lOnbPlanner = Object.assign({}, curRec)
      this.lOnbPlanner.onb_plan_end_dt = this.lOnbPlanner.onb_plan_end_dt ? handy.formatDBDate(this.lOnbPlanner.onb_plan_end_dt) : null
      this.lOnbPlanner.onb_actual_end_dt = this.lOnbPlanner.onb_actual_end_dt ? handy.formatDBDate(this.lOnbPlanner.onb_actual_end_dt) : null
      this.lOnbPlanner.action = 'update'
      this.loadResponsibiltyEmpList()
      this.loadOnboardingReviewDetails()
      this.showOnbPlanner = true
    },
    loadResponsibiltyEmpList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMIAllResponseList/', qry)
      .then(response => {
        this.responsibilityEmpList = response.data.filter(rec =>rec.mi_status === "Active")
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadVendorSupplierCategoryList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getListOfMIVendorSupplierCat/', qry)
      .then(response => {
        this.vendorSupplierCategoryList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadVendorSupplierSubCategoryList (curItem) {
      var qry = {
        params: {
          vendorsupplier_cat_id: curItem.vendorsupplier_cat_id
        }
      }
      this.vendorSupplierSubCategoryList = []
      this.vendorSupplierList = []
      this.axios.get(config.API_URL + '/getListOfMIVendorSupplierSubCatByCatId/', qry)
      .then(response => {
        this.vendorSupplierSubCategoryList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadVendorSupplierList (curItem) {
      var qry = {
        params: {
          vendorsupplier_cat_id: curItem.vendorsupplier_cat_id,
          vendorsupplier_sub_cat_id: curItem.vendorsupplier_sub_cat_id,
          vendor_id: config.VENDOR_ID
        }
      }
      // this.vendorSupplierList = []
      this.axios.get(config.API_URL + '/getListOfMIVendorSupplierDetailsbyCatIdSubCatId/', qry)
      .then(response => {
        this.vendorSupplierList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showAnyNewContractVersionApprovedBasedonProjId () {
      var qry = {
        params: {
          proj_id: this.lOnboardReviewBase.proj_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.showContractImportSection = false
      this.lOnboardReviewBase.new_proj_contract_base_id = 0
      this.axios.get(config.API_URL + '/getMIAllContractListForProjId/', qry)
      .then(response => {
        // get approved contract detail
        this.approvedContractList = response.data.filter(rec => rec.status === 'Approved')
        if (this.approvedContractList.length === 0) {
          this.msg('There is no Approved Project Contract for the selected project. Please review project contract page.', 0)
        } else {
          // projContractList is loaded from contract_map_table. See approved version contract_base_id is present in the contract_map_table.
          // if present, no action is required.
          // if not present, it means new contract version is approved in the project contract table and that need to be imported in onb_contract_map table.
          // whether approved contract present in the onboarding contract list loaded from contract map table (projContractList).
          this.tempContractList = this.projContractList.filter(rec => rec.proj_contract_base_id === this.approvedContractList[0].proj_contract_base_id)
          if (this.tempContractList.length === 0)  {
            this.lOnboardReviewBase.new_proj_contract_base_id = this.approvedContractList[0].proj_contract_base_id
            this.lOnboardReviewBase.new_proj_contract_version_no = 'Version ' + this.approvedContractList[0].version + '.0'
          } else {
            this.lOnboardReviewBase.new_proj_contract_base_id = this.lOnboardReviewBase.proj_contract_base_id
          }
          if(this.lOnboardReviewBase.new_proj_contract_base_id === this.lOnboardReviewBase.proj_contract_base_id) {
            this.showContractImportSection = false
          } else {
            // need to make true if the new_proj_contract_base_id is not in the this.projContractList.
            var tmpContList = []
            tmpContList = this.projContractList.filter(rec => rec.proj_contract_base_id === this.lOnboardReviewBase.new_proj_contract_base_id)
            if (tmpContList.length === 0) {
              this.showContractImportSection = true
            }
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    changeProjectContractBaseIDforOnboardReview() {
      this.loadOnboardingReviewDetails()
    },
    importNewApprovedContractDetails() {
      this.lOnboardReviewBase.vendor_id = config.VENDOR_ID
      this.lOnboardReviewBase.source = this.source_var // Onboarding
      this.lOnboardReviewBase.old_proj_contract_base_id = this.lOnboardReviewBase.proj_contract_base_id
      this.axios.post(config.API_URL + '/miAddContractBaseIDMIBaseCombo/addprojcontractbaseid', this.lOnboardReviewBase)
      .then(response => {
        // refresh stats
        this.importNewApprovedContractManpowerDetail()
        this.importNewApprovedContractServiceDetail()
        this.showContractImportSection = false
        this.loadCommunity()
        this.loadProjectBasedOnCommId (this.lOnboardReviewBase)
        this.loadProjectContractBasedOnMIBaseID (this.lOnboardReviewBase)
        setTimeout(() => {
          this.loadOnboardingReviewDetails()
        }, 500)
      })
      .catch(err => {
        this.msg('Project approved contract version alreay imported. Please refresh the page.', 0)
      })
    },
    importNewApprovedContractManpowerDetail () {
      // This method to import the new approved contract details to onboarding/ operation review. Need to use new_proj_contract_base_id to import.
      // First get the list of records in the sv_mi_onboard_mandep_det table based on mi_base_id, new_proj_contract_base_id by comparing with sv_mi_base_contract_map.
      // if no record found import the contract details to sv_mi_onboard_mandep_det else do not import.
      // Because contract details are already imported and the records are already present in the table.
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.new_proj_contract_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      // import for sv_mi_onboard_mandep_det
      this.axios.get(config.API_URL + '/getIsMandepDetImportedFromProjectContract/', qry)
      .then(resp => {
        if (resp.data.length === 0) {
          // up in db
          this.lOnboardReviewBase.vendor_id = config.VENDOR_ID
          this.lOnboardReviewBase.updated_by = config.EMP_ID
          this.beingSaved = true
          this.axios.post(config.API_URL + '/miOnbOprReviewContractMandepDetImport/import-newly-approved', this.lOnboardReviewBase)
          .then(response => {
            if (response.data === 'success') {
              this.msg('Contract Manpower and Service Details Imported Successfully', 1)
            } else {
              this.msg(response.data, 0)
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.beingSaved = false
    },
    importNewApprovedContractServiceDetail () {
      // This method to import the new approved contract details to onboarding/ operation review. Need to use new_proj_contract_base_id to import.
      // First get the list of records in the sv_mi_onboard_service table based on mi_base_id, new_proj_contract_base_id by comparing with sv_mi_base_contract_map.
      // if no record found import the contract details to sv_mi_onboard_service else do not import.
      // Because contract details are already imported and the records are already present in the table.
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.new_proj_contract_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      // import for sv_mi_onboard_service
      this.axios.get(config.API_URL + '/getIsMIServiceImportedFromProjectContract/', qry)
      .then(resp => {
        if (resp.data.length === 0) {
          // up in db
          this.lOnboardReviewBase.vendor_id = config.VENDOR_ID
          this.lOnboardReviewBase.updated_by = config.EMP_ID
          this.beingSaved = true
          this.axios.post(config.API_URL + '/miOnbOprReviewContractServiceImport/import-newly-approved', this.lOnboardReviewBase)
          .then(response => {
            if (response.data === 'success') {
              this.msg('Contract Manpower and Service Details Imported Successfully', 1)
            } else {
              this.msg(response.data, 0)
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.beingSaved = false
    },
    prepareCreateVoiceofCust () {
      this.lVoice = {
        sales_review_voice_of_cust: '',
        sales_review_voice_of_cust_remarks: '',
        source: this.source_var, // onboarding
        mi_base_id: this.lOnboardReviewBase.mi_base_id,
        action: 'create'
      }
      this.showVoice = true
    },
    saveVoiceofCustChanges () {
      if (this.lVoice.mi_voice_of_cust) {
        this.axios.post(config.API_URL + '/miOnbOprReviewVoiceofCustomer/', this.lVoice)
        .then(response => {
          this.loadOnboardingReviewDetails()
          this.msg('Saved Successfully', 1)
          this.showVoice = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter voice of customer question', 0)
      }
    },
    prepareVoiceofCustUpdate (curRec) {
      this.lVoice = Object.assign({}, curRec)
      this.lVoice.action = 'update'
      this.showVoice = true
    },
    prepareVoiceofCustImport (filterList) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.mi_voice_of_customer_id) : null
        }
      }
      this.voiceOfCustDetList = []
      this.axios.get(config.API_URL + '/getListOfVoiceofCustConfigDetailBasedOnBaseId/', qry)
      .then(response => {
        this.voiceOfCustDetList = response.data
        this.selected = []
        this.showListOfVoiceofCustDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToVoiceOfCust (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          source: this.source_var
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/miOnbOprReviewVoiceOfCustImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfVoiceofCustDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadOnboardingReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select item from the list to import.', 0)
      }
    },
    prepareCreateCustExpect () {
      this.lCust = {
        mi_freq_id: null,
        mi_cust_expectation: '',
        category: '',
        sales_review_cust_expect_remarks: '',
        source: this.source_var, // onboarding
        mi_base_id: this.lOnboardReviewBase.mi_base_id,
        action: 'create'
      }
      this.loadFrequency()
      this.showCust = true
    },
    saveCustExpectChanges () {
      if (this.lCust.mi_cust_expectation && this.lCust.category && this.lCust.mi_freq_id) {
        this.axios.post(config.API_URL + '/miOnbOprReviewCustExpect/', this.lCust)
        .then(response => {
          this.loadOnboardingReviewDetails()
          this.msg('Saved Successfully', 1)
          this.showCust = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please fill the mandatory field', 0)
      }
    },
    prepareCustExpectUpdate (curRec) {
      this.loadFrequency()
      this.lCust = Object.assign({}, curRec)
      this.lCust.action = 'update'
      this.showCust = true
    },
    loadFrequency () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.freqItem = []
      this.axios.get(config.API_URL + '/getListOfFreqBasedonVendorId/', qry)
      .then(response => {
        this.freqItem = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCustExpectImport (filterList) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.mi_customer_expectation_id) : null
        }
      }
      this.custExpectDetList = []
      this.axios.get(config.API_URL + '/getListOfCustExpectConfigDetailBasedOnBaseId/', qry)
      .then(response => {
        this.custExpectDetList = response.data
        this.selected = []
        this.showListOfCustExpectDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToCustExpect (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          mi_base_id: this.lOnboardReviewBase .mi_base_id,
          source: this.source_var // "Onboarding"
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/miOnbOprReviewCustExpectImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfCustExpectDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadOnboardingReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select item from the list to import.', 0)
      }
    },
    prepareCreateUniCommit () {
      this.lUniCommit = {
        mi_freq_id: null,
        sv_sales_review_uni_commit: '',
        category: '',
        sales_review_uni_commit_remarks: '',
        source: this.source_var, // onboarding
        mi_base_id: this.lOnboardReviewBase.mi_base_id,
        action: 'create'
      }
      this.loadFrequency()
      this.showUniserviceCommit = true
    },
    saveUniCommitChanges () {
      if (this.lUniCommit.category && this.lUniCommit.mi_uni_commit && this.lUniCommit.mi_freq_id) {
        this.axios.post(config.API_URL + '/miOnbOprReviewUniCommit/', this.lUniCommit)
        .then(response => {
          this.loadOnboardingReviewDetails()
          this.msg('Saved Successfully', 1)
          this.showUniserviceCommit = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter description and category', 0)
      }
    },
    prepareUniCommitUpdate (curRec) {
      this.loadFrequency()
      this.lUniCommit = Object.assign({}, curRec)
      this.lUniCommit.action = 'update'
      this.showUniserviceCommit = true
    },
    prepareUniCommitImport (filterList) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.mi_uniservice_commit_id) : null
        }
      }
      this.uniCommitDetList = []
      this.axios.get(config.API_URL + '/getListOfUniCommitmentConfigDetailBasedOnBaseId/', qry)
      .then(response => {
        this.uniCommitDetList = response.data
        this.selected = []
        this.showListOfUniCommitDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToUniCommit (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          source: this.source_var // "Onboarding"
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/miOnbOprReviewUniCommitImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfUniCommitDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadOnboardingReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select item from the list to import.', 0)
      }
    },
    prepareUploadDocs () {
      this.lUploadDoc = {
        mi_base_id: this.lOnboardReviewBase.mi_base_id,
        source: this.source_var, // onboarding
        mi_doc_remarks: '',
        files: []
      }
      this.showOnboardingDocUpload = true
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curProject) {
      curProject.source = this.source_var // "Onboarding"
      let currentDate = new Date()
      let time = currentDate.getHours() + "-" + currentDate.getMinutes() + "-" + currentDate.getSeconds()
      const files = event.target.files
      if (!curProject.files) {
        curProject.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curProject.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name.split('.')[0] + '_' + handy.formatDBDate(currentDate) + '_' + time + '.' + file.name.split('.')[1],
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
      this.$refs.fileInput.value = ''
    },
    removeSelectedFile (curFile) {
      curFile.is_selected = false
      this.$forceUpdate()
    },
    saveUploadedDocs () {
      if (this.lUploadDoc.files && this.lUploadDoc.files.length > 0 && this.lUploadDoc.mi_doc_remarks && this.lUploadDoc.mi_doc_type ) {
        this.axios.post(config.API_URL + '/miReviewDocumentAttach/', this.lUploadDoc)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.showOnboardingDocUpload = false
          this.loadOnboardingReviewDetails()
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please select file, document type and remarks.', 0)
      }
    },
    updateDocItems (curRec) {
      this.lUploadDoc = Object.assign({}, curRec)
      if (!this.lUploadDoc.files) {
        this.lUploadDoc.files = []
      }
      this.lUploadDoc.files.push({
        is_selected: curRec.is_selected,
        is_changed: curRec.is_changed,
        file_name: curRec.file_name
      })
      this.showOnboardingDocUpload = true
    },
    showBasicInformationOfCommunity (curOnboardReviewBase) {
      if (curOnboardReviewBase.comm_pair && curOnboardReviewBase.comm_pair.comm_id) {
        var qry = {
          params: {
            comm_id: curOnboardReviewBase.comm_pair.comm_id
          }
        }
        this.commBasicInformationList = []
        this.axios.get(config.API_URL + '/getBasicInformationofCommunity/', qry)
        .then(response => {
          this.commBasicInformationList = response.data
          this.showCommunityInfo = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    showBasicInformationOfProject (curOnboardReviewBase) {
      if (curOnboardReviewBase.proj_pair && curOnboardReviewBase.proj_pair.proj_id) {
        var qry = {
          params: {
            proj_id: curOnboardReviewBase.proj_pair.proj_id
          }
        }
        this.projBasicInformationList = []
        this.axios.get(config.API_URL + '/getBasicInformationofProject/', qry)
        .then(response => {
          this.projBasicInformationList = response.data
          this.showProjectInfo = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    showBasicInformationOfProjectContract (curOnboardReviewBase) {
      if (curOnboardReviewBase.proj_contract_base_id) {
        var qry = {
          params: {
            proj_contract_base_id: curOnboardReviewBase.proj_contract_base_id
          }
        }
        this.projContractInformationList = []
        this.axios.get(config.API_URL + '/getBasicInformationofProjectContract/', qry)
        .then(response => {
          this.projContractInformationList = response.data
          this.showProjectContractInfo = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    changeView (curTab) {
      if (curTab === 'Proposal breakup') {
        this.attTab = 'tab-0'
      } else if (curTab === 'end-to-end proposal') {
        this.attTab = 'tab-1'
      } else if (curTab === 'compressed view') {
        this.attTab = 'tab-2'
      } else {
        this.attTab = 'tab-3'
      }
    },
    prepareViewProjContract (curContract) {
      var qry = {
        params: {
          proj_contract_base_id: curContract.proj_contract_base_id
        }
      }
      this.axios.get(config.API_URL + '/getProjContractViewAsPdf/', qry)
      .then(response => {
        this.projContractView = response.data
        this.projContractView.forEach(rec => {
          if (rec.length) {
            if (!rec.total_amount) {
              rec.total_amount = 0
            }
            if (!rec.gst_amt || !rec.before_gst) {
              rec.gst_tax_amt = 0
              rec.tax_amt = 0
              rec.before_gst = 0
            }
            if (!rec.mgmt) {
              rec.mgmt = 0
            }
            rec.forEach(records => {
              if (records.amount) {
                rec.total_amount += records.amount
              }
              if (records.total_hc_amt) {
                rec.total_amount += records.total_hc_amt
              }
              rec.mgmt += records.Mgmt_fee_amt
              rec.tax_amt += records.tax_amt
              rec.before_gst = rec.total_amount + rec.mgmt
              rec.gst_tax_amt = rec.before_gst + rec.tax_amt
            })
          }
        })
        this.showContractViewAsPdf = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareManDepInhouseDetUpdate (curRec) {
      if (curRec.emp_id) {
        curRec.onb_responsible_pair_id = []
        curRec.emp_id.split(",").forEach(rec => {
          curRec.onb_responsible_pair_id.push(parseInt(rec))
        })
      }
      this.lOnbManpowerInhouseDet = Object.assign({}, curRec)
      this.lOnbManpowerInhouseDet.onb_responsible_pair_id = curRec.onb_responsible_pair_id
      this.lOnbManpowerInhouseDet.onb_plan_end_dt = this.lOnbManpowerInhouseDet.onb_plan_end_dt ? handy.formatDBDate(this.lOnbManpowerInhouseDet.onb_plan_end_dt) : null
      this.lOnbManpowerInhouseDet.onb_actual_end_dt = this.lOnbManpowerInhouseDet.onb_actual_end_dt ? handy.formatDBDate(this.lOnbManpowerInhouseDet.onb_actual_end_dt) : null
      this.lOnbManpowerInhouseDet.action = 'update'
      this.loadResponsibiltyEmpList()
      this.loadOnboardingManDepItemList()
      this.showOnbManDepInhouseDet = true
    },
    saveManDepInhouseDetChanges () {
      if (this.lOnbManpowerInhouseDet.onb_plan_end_dt && this.lOnbManpowerInhouseDet.onb_status) {
        this.lOnbManpowerInhouseDet.vendor_id = config.VENDOR_ID
        this.lOnbManpowerInhouseDet.update_user = config.EMP_ID
        this.lOnbManpowerInhouseDet.onb_responsible = this.lOnbManpowerInhouseDet.onb_responsible_pair_id ? this.lOnbManpowerInhouseDet.onb_responsible_pair_id.map(rec => rec.emp_id) : null
        this.axios.post(config.API_URL + '/miOnboardingManpowerorServiceDetUpdate/inhouse', this.lOnbManpowerInhouseDet)
        .then(response => {
          this.loadOnboardingManDepItemList()
          this.msg('Saved Successfully', 1)
          this.showOnbManDepInhouseDet = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    prepareManDepOutsourceDetUpdate (curRec) {
      if (curRec.emp_id) {
        curRec.onb_responsible_pair_id = []
        curRec.emp_id.split(",").forEach(rec => {
          curRec.onb_responsible_pair_id.push(parseInt(rec))
        })
      }
      this.lOnbManpowerOutsourceDet = Object.assign({}, curRec)
      this.lOnbManpowerOutsourceDet.onb_responsible_pair_id = curRec.onb_responsible_pair_id
      this.lOnbManpowerOutsourceDet.onb_plan_end_dt = this.lOnbManpowerOutsourceDet.onb_plan_end_dt ? handy.formatDBDate(this.lOnbManpowerOutsourceDet.onb_plan_end_dt) : null
      this.lOnbManpowerOutsourceDet.onb_actual_end_dt = this.lOnbManpowerOutsourceDet.onb_actual_end_dt ? handy.formatDBDate(this.lOnbManpowerOutsourceDet.onb_actual_end_dt) : null
      this.lOnbManpowerOutsourceDet.action = 'update'
      this.loadVendorSupplierCategoryList()
      this.loadVendorSupplierSubCategoryList(this.lOnbManpowerOutsourceDet)
      this.loadVendorSupplierList(this.lOnbManpowerOutsourceDet)
      this.loadResponsibiltyEmpList()
      this.loadOnboardingManDepItemList()
      this.showOnbManDepOutsourceDet = true
    },
    saveManDepOutsourceDetChanges () {
      if (this.lOnbManpowerOutsourceDet.vendorsupplier_cat_id && this.lOnbManpowerOutsourceDet.vendorsupplier_sub_cat_id && this.lOnbManpowerOutsourceDet.vendorsupplier_id && this.lOnbManpowerOutsourceDet.onb_plan_end_dt && this.lOnbManpowerOutsourceDet.onb_status) {
        this.lOnbManpowerOutsourceDet.vendor_id = config.VENDOR_ID
        this.lOnbManpowerOutsourceDet.update_user = config.EMP_ID
        this.lOnbManpowerOutsourceDet.onb_responsible = this.lOnbManpowerOutsourceDet.onb_responsible_pair_id ? this.lOnbManpowerOutsourceDet.onb_responsible_pair_id.map(rec => rec.emp_id) : null
        this.axios.post(config.API_URL + '/miOnboardingManpowerorServiceDetUpdate/outsource', this.lOnbManpowerOutsourceDet)
        .then(response => {
          this.loadOnboardingManDepItemList()
          this.msg('Saved Successfully', 1)
          this.showOnbManDepOutsourceDet = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    prepareOtherServiceDetUpdate (curRec) {
      if (curRec.emp_id) {
        curRec.onb_responsible_pair_id = []
        curRec.emp_id.split(",").forEach(rec => {
          curRec.onb_responsible_pair_id.push(parseInt(rec))
        })
      }
      this.lOnbOtherServiceDet = Object.assign({}, curRec)
      this.lOnbOtherServiceDet.onb_responsible_pair_id = curRec.onb_responsible_pair_id
      this.lOnbOtherServiceDet.onb_plan_end_dt = this.lOnbOtherServiceDet.onb_plan_end_dt ? handy.formatDBDate(this.lOnbOtherServiceDet.onb_plan_end_dt) : null
      this.lOnbOtherServiceDet.onb_actual_end_dt = this.lOnbOtherServiceDet.onb_actual_end_dt ? handy.formatDBDate(this.lOnbOtherServiceDet.onb_actual_end_dt) : null
      this.lOnbOtherServiceDet.action = 'update'
      this.loadVendorSupplierCategoryList()
      this.loadVendorSupplierSubCategoryList(this.lOnbOtherServiceDet)
      this.loadVendorSupplierList(this.lOnbOtherServiceDet)
      this.loadResponsibiltyEmpList()
      this.loadOnboardingOtherServiceEngageItemList()
      this.showOnbOtherServiceDet = true
    },
    saveOtherServiceDetChanges () {
      if (!this.lOnbOtherServiceDet.onb_ser_type || !this.lOnbOtherServiceDet.onb_plan_end_dt || !this.lOnbOtherServiceDet.onb_status) {
        this.msg('Please enter all mandatory fields', 0)
      } else if (this.lOnbOtherServiceDet.onb_ser_type === 'Outsource' && (!this.lOnbOtherServiceDet.vendorsupplier_cat_id || !this.lOnbOtherServiceDet.vendorsupplier_sub_cat_id || !this.lOnbOtherServiceDet.vendorsupplier_id)) {
        this.msg('Please select vendor details', 0)
      } else {
        this.lOnbOtherServiceDet.vendor_id = config.VENDOR_ID
        this.lOnbOtherServiceDet.update_user = config.EMP_ID
        this.lOnbOtherServiceDet.onb_responsible = this.lOnbOtherServiceDet.onb_responsible_pair_id ? this.lOnbOtherServiceDet.onb_responsible_pair_id.map(rec => rec.emp_id) : null
        this.axios.post(config.API_URL + '/miOnboardingManpowerorServiceDetUpdate/otherservice', this.lOnbOtherServiceDet)
        .then(response => {
          this.loadOnboardingOtherServiceEngageItemList()
          this.msg('Saved Successfully', 1)
          this.showOnbOtherServiceDet = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    prepareOnBoardRemainingOtherServiceImport (filterList) {
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          vendor_id: config.VENDOR_ID,
          filter: [],
          type: 'all'
        }
      }
      // calling get method with empty filter. This will return all project contract service details for the mi_base_id, proj_contract_base_id and vendor_id combination.
      this.otherServiceFilter = []
      this.otherServiceImportEntireList = []
      this.axios.get(config.API_URL + '/getMIOnbReviewListOfContractOtherServiceDetForImport/', qry)
      .then(response => {
        this.otherServiceImportEntireList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
      // timeout is added since the methods are executing before the above get method.
      setTimeout(() => {
        // filterList is a parameter, this has already imported onboarding service details.
        // Now build the filter based on the existing proj_contract_service_det_id and append with ','. This will be used to get remaining service details.
        this.otherServiceImportEntireList.forEach( rec => {
          filterList.forEach( records => {
            if (rec.mi_base_id === records.mi_base_id && rec.proj_contract_sub_cat_id === records.proj_contract_sub_cat_id && rec.amount === records.onb_budget && rec.proj_contract_base_id === records.proj_contract_base_id ) {
              this.otherServiceFilter.push(rec.proj_contract_service_det_id)
            }
          })
        })
        // call service det load mothod with filter list. This method will load the remaining service det list for the mi_base_id, proj_contract_base_id and vendor_id combination.
        var qry_serdet = {
          params: {
            mi_base_id: this.lOnboardReviewBase.mi_base_id,
            proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
            vendor_id: config.VENDOR_ID,
            filter: this.otherServiceFilter,
            type: 'remaining'
          }
        }
        this.otherServiceImportRemainingList = []
        this.axios.get(config.API_URL + '/getMIOnbReviewListOfContractOtherServiceDetForImport/', qry_serdet)
        .then(response => {
          this.otherServiceImportRemainingList = response.data
          this.selected = []
          this.otherServiceFilter = []
          this.showListOfOnbOtherServiceImport = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }, 500)
    },
    importToOnbOtherServiceEngagement (curSelectedArray) {
      this.otherServiceRemainingId = []
      if (curSelectedArray.length > 0) {
        curSelectedArray.forEach (rec => {
          this.otherServiceRemainingId.push(rec.proj_contract_service_det_id)
        })
        curSelectedArray.push({
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          vendor_id: config.VENDOR_ID,
          updated_by: config.EMP_ID,
          source: this.source_var, // Onboarding
          filter: this.otherServiceRemainingId
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/miOnbOprReviewContractServiceImport/import-remaining', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfOnbOtherServiceImport = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadOnboardingReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select item from list to import.', 0)
      }
    },
    prepareAddVoiceofCustHistory (curVoiceOFCustItem) {
      this.voiceOfCustBasicDet = curVoiceOFCustItem
      this.showVoiceOfCustHistory = true
      this.loadVoiceOFCustHistoryList()
    },
    preparecreateVoiceOfCustHistory () {
      this.lVoiceOfCustHistory = {
        mi_base_id: this.voiceOfCustBasicDet.mi_base_id,
        mi_voice_of_cust_id: this.voiceOfCustBasicDet.mi_voice_of_cust_id,
        start_dt: null,
        remarks: '',
        source: this.source_var, // "Onboarding",
        created_by: null,
        created_date: null,
        updated_by: null,
        updated_date: null,
        action: 'create-voice-cust-hist'
      }
      this.createVoiceOfCustHistory = true
    },
    saveVoiceOfCustHistory (action) {
      if (this.lVoiceOfCustHistory.start_dt && this.lVoiceOfCustHistory.remarks) {
        this.lVoiceOfCustHistory.vendor_id = config.VENDOR_ID
        this.lVoiceOfCustHistory.created_by = config.EMP_ID
        this.lVoiceOfCustHistory.updated_by = config.EMP_ID
        this.axios.post(config.API_URL + '/OnbOprvoiceOfCustHistory/' + action, this.lVoiceOfCustHistory)
        .then(response => {
          this.loadVoiceOFCustHistoryList()
          this.msg('Saved Successfully', 1)
          this.createVoiceOfCustHistory = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    loadVoiceOFCustHistoryList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          mi_voice_of_cust_id: this.voiceOfCustBasicDet.mi_voice_of_cust_id
        }
      }
      this.axios.get(config.API_URL + '/getVoiceOfCustHistoryList/', qry)
      .then(response => {
        this.voiceOfCustHistoryList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdateVoiceOfCustHistory (curRec) {
      this.lVoiceOfCustHistory = Object.assign({}, curRec)
      this.lVoiceOfCustHistory.action = 'update-voice-cust-hist'
      this.lVoiceOfCustHistory.start_dt = this.lVoiceOfCustHistory.start_dt ? handy.formatDBDate(this.lVoiceOfCustHistory.start_dt) : null
      this.createVoiceOfCustHistory = true
    },
    deleteVoiceOfCustHistory (curRec) {
      if (!confirm('Sure, you want to delete Voice of Customer history : "' + this.voiceOfCustBasicDet.mi_voice_of_cust + '"? ' )) {
        return
      }
      this.lVoiceOfCustHistory.action = 'delete-voice-cust-hist'
      curRec.is_deleted = '1'
      curRec.deleted_by = config.EMP_ID
      this.axios.post(config.API_URL + '/OnbOprvoiceOfCustHistory/' + this.lVoiceOfCustHistory.action, curRec)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadVoiceOFCustHistoryList()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCustExpectHistory (curCustExpect) {
      this.custExpectBasicDet = curCustExpect
      this.showCustExpectHistory = true
      this.loadCustExpectHistoryList()
    },
    prepareCreateCustExpectHistory () {
      this.lCustExpectHistory = {
        mi_base_id: this.custExpectBasicDet.mi_base_id,
        mi_cust_expectation_id: this.custExpectBasicDet.mi_cust_expectation_id,
        start_dt: null,
        remarks: '',
        source: this.source_var, // "Onboarding",
        created_by: null,
        created_date: null,
        updated_by: null,
        updated_date: null,
        action: 'create-cust-expect-hist'
      }
      this.createCustExpectHistory = true
    },
    loadCustExpectHistoryList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          mi_cust_expectation_id: this.custExpectBasicDet.mi_cust_expectation_id
        }
      }
      this.axios.get(config.API_URL + '/getCustExpectHistoryList/', qry)
      .then(response => {
        this.custExpectHistoryList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    saveCustExpectHistory (action) {
      if (this.lCustExpectHistory.start_dt && this.lCustExpectHistory.remarks) {
        this.lCustExpectHistory.vendor_id = config.VENDOR_ID
        this.lCustExpectHistory.created_by = config.EMP_ID
        this.lCustExpectHistory.updated_by = config.EMP_ID
        this.axios.post(config.API_URL + '/OnbOprCustExpectHistory/' + action, this.lCustExpectHistory)
        .then(response => {
          this.loadCustExpectHistoryList()
          this.msg('Saved Successfully', 1)
          this.createCustExpectHistory = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    prepareUpdateCustExpectHistory (curRec) {
      this.lCustExpectHistory = Object.assign({}, curRec)
      this.lCustExpectHistory.action = 'update-cust-expect-hist'
      this.lCustExpectHistory.start_dt = this.lCustExpectHistory.start_dt ? handy.formatDBDate(this.lCustExpectHistory.start_dt) : null
      this.createCustExpectHistory = true
    },
    deleteCustExpectHistory (curRec) {
      if (!confirm('Sure, you want to delete Customer Expectation history : "' + this.custExpectBasicDet.mi_cust_expectation + '"? ' )) {
        return
      }
      this.lCustExpectHistory.action = 'delete-cust-expect-hist'
      curRec.is_deleted = '1'
      curRec.deleted_by = config.EMP_ID
      this.axios.post(config.API_URL + '/OnbOprCustExpectHistory/' + this.lCustExpectHistory.action, curRec)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadCustExpectHistoryList()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUniCommitHistory (curUniCommit) {
      this.showUniCommitHistory = true
      this.uniCommitBasicDet = curUniCommit
      this.loadUniCommitHistoryList()
    },
    prepareCreateUniCommitHistory () {
      this.lUniCommitHistory = {
        mi_base_id: this.uniCommitBasicDet.mi_base_id,
        mi_uni_commit_id: this.uniCommitBasicDet.mi_uni_commit_id,
        start_dt: null,
        remarks: '',
        source: this.source_var, // "Onboarding",
        created_by: null,
        created_date: null,
        updated_by: null,
        updated_date: null,
        action: 'create-uni-commit-hist'
      }
      this.createUniCommitHistory = true
    },
    saveUniCommitHistory (action) {
      if (this.lUniCommitHistory.start_dt && this.lUniCommitHistory.remarks) {
        this.lUniCommitHistory.vendor_id = config.VENDOR_ID
        this.lUniCommitHistory.created_by = config.EMP_ID
        this.lUniCommitHistory.updated_by = config.EMP_ID
        this.axios.post(config.API_URL + '/OnbOprUniserviceCommitHistory/' + action, this.lUniCommitHistory)
        .then(response => {
          this.loadUniCommitHistoryList()
          this.msg('Saved Successfully', 1)
          this.createUniCommitHistory = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    loadUniCommitHistoryList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          mi_uni_commit_id: this.uniCommitBasicDet.mi_uni_commit_id
        }
      }
      this.axios.get(config.API_URL + '/getUniCommitHistoryList/', qry)
      .then(response => {
        this.uniCommitHistoryList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdateUniCommitHistory (curRec) {
      this.lUniCommitHistory = Object.assign({}, curRec)
      this.lUniCommitHistory.action = 'update-uni-commit-hist'
      this.lUniCommitHistory.start_dt = this.lUniCommitHistory.start_dt ? handy.formatDBDate(this.lUniCommitHistory.start_dt) : null
      this.createUniCommitHistory = true
    },
    deleteUniCommitHistory (curRec) {
      if (!confirm('Sure, you want to delete Uniservice Commitment history : "' + this.uniCommitBasicDet.category + '"? ' )) {
        return
      }
      this.lUniCommitHistory.action = 'delete-uni-commit-hist'
      curRec.is_deleted = '1'
      curRec.deleted_by = config.EMP_ID
      this.axios.post(config.API_URL + '/OnbOprUniserviceCommitHistory/' + this.lUniCommitHistory.action, curRec)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadUniCommitHistoryList()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareOnBoardRemainingMandepImport () {
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          vendor_id: config.VENDOR_ID,
          filter: [],
          type: 'all'
        }
      }
      // calling get method with empty filter. This will return all project contract staff details for the mi_base_id, proj_contract_base_id and vendor_id combination.
      this.onbMandepFilter = []
      this.onbContractMandepImportEntireList = []
      this.axios.get(config.API_URL + '/getMIOnbReviewListOfContractMandepDetForImport/', qry)
      .then(response => {
        this.onbContractMandepImportEntireList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
      // timeout is added since the methods are executing before the above get method.
      setTimeout(() => {
        // manpowerDepItemList is a parameter with entire mandep details already in sv_mi_onboard_mandep_det for both inhouse and outsourced.
        // Now build the filter based on the existing proj_contract_staff_det_id to collection array. This will be used to get remaining mandep details.
        this.onbContractMandepImportEntireList.forEach( rec => {
          this.manpowerDepItemList.forEach( records => {
            if (rec.mi_base_id === records.mi_base_id && rec.role_id === records.role_id && rec.amt_per_hc === records.onb_budget_cost && rec.proj_contract_base_id === records.proj_contract_base_id ) {
              this.onbMandepFilter.push(rec.proj_contract_staff_det_id)
            }
          })
        })
        // call mandep det load mothod with filter list. This method will load the remaining outsource mandep det list for the mi_base_id, proj_contract_base_id and vendor_id combination.
        var qry_mandepdet = {
          params: {
            mi_base_id: this.lOnboardReviewBase.mi_base_id,
            proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
            vendor_id: config.VENDOR_ID,
            filter: this.onbMandepFilter,
            type: 'remaining'
          }
        }
        this.onbMandepImportRemainingList = []
        this.axios.get(config.API_URL + '/getMIOnbReviewListOfContractMandepDetForImport/', qry_mandepdet)
        .then(response => {
          this.onbMandepImportRemainingList = response.data
          this.selected = []
          this.onbMandepFilter = []
          this.showListOfOnbMandepImport = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }, 500)
    },
    importToOnbManpowerDeployment (curSelectedArray) {
      this.onbMandepRemainingId = []
      if (curSelectedArray.length > 0) {
        curSelectedArray.forEach (rec => {
          this.onbMandepRemainingId.push(rec.proj_contract_staff_det_id)
        })
        curSelectedArray.push({
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
          vendor_id: config.VENDOR_ID,
          updated_by: config.EMP_ID,
          source: this.source_var, // Onboarding
          filter: this.onbMandepRemainingId
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/miOnbOprReviewContractMandepDetImport/import-remaining', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfOnbMandepImport = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadOnboardingReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select item from list to import.', 0)
      }
    },
    validateOnbPlannerStatus() {
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.showOnbPlannerValidationSummary = true
      this.isOndReviewValid = false
      this.onboardPlannerValidationStatusList = []
      this.axios.get(config.API_URL + '/getOnbPlannerStatusList/', qry)
      .then(response => {
        this.onboardPlannerValidationStatusList = response.data
        var onbInvalidCnt = []
        onbInvalidCnt = response.data.filter(rec => rec.is_valid === "Invalid")
        if(onbInvalidCnt && onbInvalidCnt.length > 0) {
          this.isOndReviewValid = false
        }
        else {
          this.isOndReviewValid = true
        }
      })
    },
    onbReviewSubmtToOperation () {
      this.validateOnbPlannerStatus()
      this.showOnbPlannerValidationSummary = false
      setTimeout(() => {
        var qry = {
          params: {
            proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
            vendor_id: config.VENDOR_ID
          }
        }
        if (!this.isOndReviewValid) {
          this.msg('Please complete all onboarding tasks before submitting to Operation', 0)
        } else {
          // Whether the Selected contract version is currently in approved status or revised with new version.
          // Ask user to select approved version if the selected version is changed to "Obsolute Approved" and any new approved version.
          this.axios.get(config.API_URL + '/getIsSelectedContractVersionStatusIsApproved/', qry)
          .then(resp => {
            if (resp.data.length > 0) {
              if (!confirm('Sure, you want to Submit Onboaring Review to Operation ?')) {
                return
              }
              // up in db
              this.lOnboardReviewBase.vendor_id = config.VENDOR_ID
              this.lOnboardReviewBase.submitted_by = config.EMP_ID

              this.axios.post(config.API_URL + '/miSalesReviewBase/Status-onb-opr', this.lOnboardReviewBase)
              .then(response => {
                // refresh stats
                this.loadOnboardingReviewDetails()
                this.loadOnboardReviewSummaryList()
              })
              .catch(err => {
                this.msg(err, 0)
              })
            } else {
              this.msg('Selected Contract Version is Obsolete Approved. Please select latest Approved contract version to submit', 0)
            }
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      }, 500)
    },
    prepareOnboardingReviewView() {
      this.showOnboardingReviewView = true
      this.loadVoiceofCustomerwithHistoryForView()
      this.loadCustomerExpectwithHistoryForView()
      this.loadUniCommitmentwithHistoryForView()
      this.loadSnagAuditActionItemwithHistoryForView()
    },
    loadVoiceofCustomerwithHistoryForView() {
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      var hist_remark = ''
      this.onbVoiceOfCustWithHitoryForViewList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewVoiceofCustHistoryForView/', qry)
      .then(response => {
        this.voiceOfCustItemList.forEach (rec => {
          hist_remark = ''
          response.data.forEach (record => {
            if(rec.mi_voice_of_cust_id === record.mi_voice_of_cust_id) {
              hist_remark = hist_remark + '[' + handy.formatDate(record.start_dt) + ']: ' + record.remarks + '\n'
            }
          })
          this.onbVoiceOfCustWithHitoryForViewList.push({
            mi_voice_of_cust: rec.mi_voice_of_cust,
            source: rec.source,
            mi_voice_of_cust_remarks: rec.mi_voice_of_cust_remarks,
            hist_remark: hist_remark,
            mi_base_id: this.lOnboardReviewBase.mi_base_id,
            proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
            vendor_id: config.VENDOR_ID,
            updated_by: config.EMP_ID
          })
        })
      })
    },
    loadCustomerExpectwithHistoryForView() {
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      var hist_remark = ''
      this.onbCustExpectWithHitoryForViewList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewCustExpectHistoryForView/', qry)
      .then(response => {
        this.custExpectItemList.forEach (rec => {
          hist_remark = ''
          response.data.forEach (record => {
            if(rec.mi_cust_expectation_id === record.mi_cust_expectation_id) {
              hist_remark = hist_remark + '[' + handy.formatDate(record.start_dt) + ']: ' + record.remarks + '\n'
            }
          })
          this.onbCustExpectWithHitoryForViewList.push({
            mi_cust_expectation_id: rec.mi_cust_expectation_id,
            category: rec.category,
            mi_cust_expectation: rec.mi_cust_expectation,
            mi_freq: rec.mi_freq,
            source: rec.source,
            mi_cust_expect_remarks: rec.mi_cust_expect_remarks,
            hist_remark: hist_remark,
            mi_base_id: this.lOnboardReviewBase.mi_base_id,
            proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
            vendor_id: config.VENDOR_ID,
            updated_by: config.EMP_ID
          })
        })
      })
    },
    loadUniCommitmentwithHistoryForView() {
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      var hist_remark = ''
      this.onbUniCommitmentWithHitoryForViewList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewUniCommitmentHistoryForView/', qry)
      .then(response => {
        this.uniCommitItemList.forEach (rec => {
          hist_remark = ''
          response.data.forEach (record => {
            if(rec.mi_uni_commit_id === record.mi_uni_commit_id) {
              hist_remark = hist_remark + '[' + handy.formatDate(record.start_dt) + ']: ' + record.remarks + '\n'
            }
          })
          this.onbUniCommitmentWithHitoryForViewList.push({
            mi_uni_commit_id: rec.mi_uni_commit_id,
            category: rec.category,
            mi_uni_commit: rec.mi_uni_commit,
            mi_freq: rec.mi_freq,
            source: rec.source,
            mi_uni_commit_remarks: rec.mi_uni_commit_remarks,
            hist_remark: hist_remark,
            mi_base_id: this.lOnboardReviewBase.mi_base_id,
            proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
            vendor_id: config.VENDOR_ID,
            updated_by: config.EMP_ID
          })
        })
      })
    },
    loadSnagAuditActionItemwithHistoryForView() {
      var qry = {
        params: {
          mi_base_id: this.lOnboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      var hist_remark = ''
      this.onbSnagAuditActionItemWithHitoryForViewList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewSnagAuditActionItemHistoryForView/', qry)
      .then(response => {
        this.snagAuditActionItemList.forEach (rec => {
          hist_remark = ''
          response.data.forEach (record => {
            if(rec.mi_snagaudit_action_id === record.mi_snagaudit_action_id) {
              hist_remark = hist_remark + '[' + handy.formatDate(record.start_dt) + ']: ' + record.remarks + '\n'
            }
          })
          this.onbSnagAuditActionItemWithHitoryForViewList.push({
            mi_snagaudit_action_id: rec.mi_snagaudit_action_id,
            category: rec.category,
            snag_des: rec.snag_des,
            snag_action_des: rec.snag_action_des,
            snag_priority: rec.snag_priority,
            status: rec.status,
            disp_short_name: rec.disp_short_name,
            plan_end_dt: rec.plan_end_dt,
            actual_end_dt: rec.actual_end_dt,
            source: rec.source,
            remarks: rec.remarks,
            hist_remark: hist_remark,
            mi_base_id: this.lOnboardReviewBase.mi_base_id,
            proj_contract_base_id: this.lOnboardReviewBase.proj_contract_base_id,
            vendor_id: config.VENDOR_ID,
            updated_by: config.EMP_ID
          })
        })
      })
    },
    prepareCreateSnagAuditAction () {
      this.lSnagAuditAction = {
        mi_base_id: this.lOnboardReviewBase.mi_base_id,
        category: '',
        snag_des: '',
        snag_action_des: '',
        snag_priority: 'Low',
        responsible_pair_id: [],
        status: 'Not Started',
        source: this.source_var, // "Onboarding",
        action: 'create',
        remarks: ''
      }
      this.showSnagAuditAction = true
    },
    prepareSnagAuditActionUpdate (curRec) {
      if (curRec.emp_id) {
        curRec.responsible_pair_id = []
        curRec.emp_id.split(",").forEach(rec => {
          curRec.responsible_pair_id.push(parseInt(rec))
        })
      }
      this.lSnagAuditAction = Object.assign({}, curRec)
      this.lSnagAuditAction.responsible_pair_id = curRec.responsible_pair_id
      this.lSnagAuditAction.plan_end_dt = this.lSnagAuditAction.plan_end_dt ? handy.formatDBDate(this.lSnagAuditAction.plan_end_dt) : null
      this.lSnagAuditAction.actual_end_dt = this.lSnagAuditAction.actual_end_dt ? handy.formatDBDate(this.lSnagAuditAction.actual_end_dt) : null
      this.lSnagAuditAction.action = 'update'
      this.loadResponsibiltyEmpList()
      this.showSnagAuditAction = true
    },
    saveSnagAuditActionDetChanges () {
      if (this.lSnagAuditAction.category && this.lSnagAuditAction.snag_des && this.lSnagAuditAction.snag_action_des && this.lSnagAuditAction.snag_priority && this.lSnagAuditAction.plan_end_dt && this.lSnagAuditAction.status) {
        this.lSnagAuditAction.vendor_id = config.VENDOR_ID
        this.lSnagAuditAction.updated_by = config.EMP_ID
        this.axios.post(config.API_URL + '/OnbOprSnagAuditActionItem/' + this.lSnagAuditAction.action, this.lSnagAuditAction)
        .then(response => {
          this.loadOnboardingReviewDetails()
          this.msg('Saved Successfully', 1)
          this.showSnagAuditAction = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    deleteSnagAuditActionDet (curRec) {
      if (!confirm('Sure, you want to delete Feedback/Snag Audit Action Item : "' + this.lSnagAuditAction.snag_action_des + '"? ' )) {
        return
      }
      this.lSnagAuditAction.action = 'delete'
      curRec.is_deleted = '1'
      curRec.updated_by = config.EMP_ID
      this.axios.post(config.API_URL + '/OnbOprSnagAuditActionItem/' + this.lSnagAuditAction.action, curRec)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadOnboardingReviewDetails()
        this.showSnagAuditAction = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareSnagAuditActionHistory (curSnagAuditItem) {
      this.showSnagAuditActionItemHistory = true
      this.snagAuditBasicDet = curSnagAuditItem
      this.loadSnagAuditActionItemHistoryList()
    },
    prepareCreateSnagAuditActionItemHistory () {
      this.lSnagAuditActionItemHistory = {
        mi_base_id: this.snagAuditBasicDet.mi_base_id,
        mi_snagaudit_action_id: this.snagAuditBasicDet.mi_snagaudit_action_id,
        start_dt: null,
        remarks: '',
        source: this.source_var, // "Onboarding",
        created_by: null,
        created_date: null,
        updated_by: null,
        updated_date: null,
        action: 'create-snag-hist'
      }
      this.createSnagAuditActionItemHistory = true
    },
    saveSnagAuditActionItemHistory (action) {
      if (this.lSnagAuditActionItemHistory.start_dt && this.lSnagAuditActionItemHistory.remarks) {
        this.lSnagAuditActionItemHistory.vendor_id = config.VENDOR_ID
        this.lSnagAuditActionItemHistory.created_by = config.EMP_ID
        this.lSnagAuditActionItemHistory.updated_by = config.EMP_ID
        this.axios.post(config.API_URL + '/OnbOprSnagAuditActionItemHistory/' + action, this.lSnagAuditActionItemHistory)
        .then(response => {
          this.loadSnagAuditActionItemHistoryList()
          this.msg('Saved Successfully', 1)
          this.createSnagAuditActionItemHistory = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    loadSnagAuditActionItemHistoryList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          mi_snagaudit_action_id: this.snagAuditBasicDet.mi_snagaudit_action_id
        }
      }
      this.axios.get(config.API_URL + '/getSnagAuditActionItemHistoryList/', qry)
      .then(response => {
        this.snagAuditActionItemHistoryList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdateSnagAuditActionItemHistory (curRec) {
      this.lSnagAuditActionItemHistory = Object.assign({}, curRec)
      this.lSnagAuditActionItemHistory.action = 'update-snag-hist'
      this.lSnagAuditActionItemHistory.start_dt = this.lSnagAuditActionItemHistory.start_dt ? handy.formatDBDate(this.lSnagAuditActionItemHistory.start_dt) : null
      this.createSnagAuditActionItemHistory = true
    },
    deleteSnagAuditActionItemHistory (curRec) {
      if (!confirm('Sure, you want to delete Feedback/Snag Audit Action Item history : "' + this.lSnagAuditActionItemHistory.remarks + '"? ' )) {
        return
      }
      this.lSnagAuditActionItemHistory.action = 'delete-snag-hist'
      curRec.is_deleted = '1'
      curRec.deleted_by = config.EMP_ID
      this.axios.post(config.API_URL + '/OnbOprSnagAuditActionItemHistory/' + this.lSnagAuditActionItemHistory.action, curRec)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadSnagAuditActionItemHistoryList()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },

  }
}
</script>

<style lang="scss">
.importtabletd.v-data-table td{
  font-weight:normal;
  font-size:12px !important;
}
.importtableth.v-data-table th{
  font-weight:bold;
  font-size:12px !important;
}
.my-label-text-size .v-label {
  font-size: 14px !important;
}
</style>
